<template>
  <div>
    <!--
    <b-card no-body >
      <b-card-body>
        <span>Programación de Fertilización</span>
      </b-card-body>
    </b-card>
    -->

    <b-card no-body>
      <div class="m-1">
        <b-row>
          <b-col
              cols="12"
              lg="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-lg-0"
          >
            <b-button-group class="mr-2">
              <b-button
                  variant="gradient-primary"
                  size="sm"
                  @click="traerTemas"
                  :disabled="loading"
                  v-b-tooltip.hover="'Recargar Datos'"
              >
                <font-awesome-icon
                    icon="fa-solid fa-arrows-rotate"
                    :spin="loading"
                />
              </b-button>
              <b-button
                  v-if="$can('create', 'Temas Capacitaciones')"
                  variant="gradient-primary"
                  size="sm"
                  v-b-modal.modal-prevent-closing
                  v-b-tooltip.hover="'Insertar Nuevo Registro'"
              >
                <font-awesome-icon icon="fa-solid fa-plus"/>
              </b-button>
              <b-button
                  v-if="$can('create', 'Temas Capacitaciones')"
                  variant="gradient-primary"
                  v-b-modal.modal-importar
                  size="sm"
                  v-b-tooltip.hover="'Importar Registros - Excel'"
              >
                <span>
                  <!-- <font-awesome-icon icon="fa-solid fa-file-excel"/> -->
                  <font-awesome-icon icon="fa-solid fa-upload"/>
                </span>
              </b-button>
              <b-button
                  v-if="$can('create', 'Temas Capacitaciones')"
                  variant="gradient-primary"
                  @click="generarExcel"
                  size="sm"
                  :disabled="loadingMasivo"
                  v-b-tooltip.hover="'Descargar Excel - Dashboard'"
              >
                <span>
                  <font-awesome-icon
                      v-if="loadingMasivo"
                      icon="fa-solid fa-arrows-rotate"
                      spin
                  />
                  <font-awesome-icon v-else icon="fa-solid fa-file-excel"/>
                </span>
              </b-button>
              <b-button
                  v-if="$can('create', 'Temas Capacitaciones')"
                  variant="gradient-primary"
                  @click="generarExcelPlantilla"
                  size="sm"
                  :disabled="loadingMasivoEditar"
                  v-b-tooltip.hover="'Descargar Excel Para Edición Masiva'"
              >
                <span>
                  <font-awesome-icon
                      v-if="loadingMasivoEditar"
                      icon="fa-solid fa-arrows-rotate"
                      spin
                  />
                  <font-awesome-icon v-else icon="fa-solid fa-database"/>
                </span>
              </b-button>
              <b-button
                  v-if="$can('edit', 'Temas Capacitaciones')"
                  @click="registrarCambios()"
                  variant="gradient-primary"
                  size="sm"
                  v-b-tooltip.hover.v-dark
                  title="Guardar cambios"
                  id="exp_ope"
                  :disabled="loadingSave"
              >
                <span v-if="loadingSave"
                ><b-spinner style="width: 16px; height: 16px"
                /></span>
                <feather-icon v-else icon="SaveIcon"/>
              </b-button>
            </b-button-group>

            <b-form-group
                v-if="$can('create', 'Temas Capacitaciones')"
                label-for="filterInput"
                class="m-lg-0 my-md-1 my-sm-1"
            >
              <b-input-group size="sm">
                <v-select
                    id="meses"
                    :options="meses_list"
                    v-model="meses_list_select"
                    :clearable="false"
                    class="select-size-sm small"
                    placeholder="Seleccionar meses.."
                />
                <b-input-group-append>
                  <b-button
                      variant="gradient-primary"
                      :disabled="!meses_list_select || loading"
                      @click="traerTemas"
                      v-b-tooltip.hover="'Buscar'"
                  >
                    <feather-icon icon="SearchIcon"/>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              lg="6"
              class="d-flex align-items-center justify-content-end mb-1 mb-lg-0"
          >
            <label class="text-bold font-weight-bold font-medium-1"
            >Mostrando {{ totalRows }} registros</label
            >
          </b-col>

          <!--
          <b-col
              cols="12"
              lg="3"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-input-group>
                <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Buscar por Tema..."
                />
                <b-input-group-append>
                  <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                  >
                    Borrar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </b-col>
          -->
        </b-row>
      </div>

      <hot-table
          ref="hotTableTemas"
          :data="items"
          licenseKey="non-commercial-and-evaluation"
      />

    </b-card>

    <!--
    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <b-form-group
          label="Mostrar"
          label-cols="5"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
            id="perPageSelect2"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
        />

      </b-form-group>
      <div>
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
        >
          <template #prev-text>
            <feather-icon
                icon="ChevronLeftIcon"
                size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
                icon="ChevronRightIcon"
                size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>
    -->

    <!-- --------MODAL DE REGISTRO NUEVO DEL TEMA----- -->
    <b-modal
        id="modal-prevent-closing"
        ref="modal_registro"
        title="Registrar Tema"
        ok-title="Registrar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        :size="loading2 ? 'md' : 'xl'"
        :cancel-disabled="loading2"
        :ok-disabled="loading2"
        :centered="loading2"
        scrollable
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        @ok="validarRegistro"
    >
      <div v-if="loading2" align="center">
        <p>Registrando ...</p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioTemas" #default="{ invalid }">
        <b-form autocomplete="off" @submit.prevent="registrarTema">
          <b-row>
            <b-col lg="12"><h4>Datos del Tema:</h4></b-col>
            <b-col lg="5">
              <b-form-group label="Nombre del Tema" label-for="tema">
                <validation-provider
                    #default="{ errors }"
                    name="Nombre del Tema"
                    vid="tema"
                    rules="required"
                >
                  <b-form-input
                      id="tema"
                      v-model="tema"
                      :state="errors.length > 0 ? false : null"
                      name="tema"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="7">
              <b-form-group label="Temario" label-for="temario">
                <validation-provider
                    #default="{ errors }"
                    name="Temario"
                    vid="temario"
                    rules=""
                >
                  <b-form-input
                      id="temario"
                      v-model="temario"
                      :state="errors.length > 0 ? false : null"
                      name="temario"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Objetivo" label-for="objetivo">
                <validation-provider
                    #default="{ errors }"
                    name="Objetivo"
                    vid="objetivo"
                    rules=""
                >
                  <b-form-input
                      id="objetivo"
                      v-model="objetivo"
                      :state="errors.length > 0 ? false : null"
                      name="objetivo"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Código" label-for="codigo">
                <validation-provider
                    #default="{ errors }"
                    name="Código"
                    vid="codigo"
                    rules=""
                >
                  <b-form-input
                      id="codigo"
                      v-model="codigo"
                      :state="errors.length > 0 ? false : null"
                      name="codigo"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Grupo Objetivo" label-for="planilla">
                <validation-provider
                    #default="{ errors }"
                    name="Grupo Objetivo"
                    vid="planilla"
                    rules=""
                >
                  <v-select
                      id="planilla"
                      v-model="planilla"
                      :options="planillas"
                      placeholder="Seleccionar G.O ..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Participantes" label-for="participantes">
                <validation-provider
                    #default="{ errors }"
                    name="Participantes"
                    vid="planparticipantesilla"
                    rules=""
                >
                  <b-form-input
                      id="participantes"
                      v-model="participantes"
                      :state="errors.length > 0 ? false : null"
                      name="participantes"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr/>
          <b-row>
            <b-col lg="12"><h4>Datos de Expositor:</h4></b-col>
            <b-col lg="2">
              <b-form-group label="DNI Expositor" label-for="dni_expositor">
                <validation-provider
                    #default="{ errors }"
                    name="DNI"
                    vid="dni_expositor"
                    rules=""
                >
                  <b-form-input
                      id="dni_expositor"
                      v-model="dni_expositor"
                      :state="errors.length > 0 ? false : null"
                      name="dni_expositor"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Nombre Expositor" label-for="expositor">
                <validation-provider
                    #default="{ errors }"
                    name="Nombre Expositor"
                    vid="expositor"
                    rules=""
                >
                  <b-form-input
                      id="expositor"
                      v-model="expositor"
                      :state="errors.length > 0 ? false : null"
                      name="expositor"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                  label="Procedencia"
                  label-for="procedencia_expositor"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Procedencia"
                    vid="procedencia_expositor"
                    rules=""
                >
                  <v-select
                      id="procedencia_expositor"
                      v-model="procedencia_expositor"
                      :options="procedencias_expositor"
                      placeholder="Seleccionar procedencia"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr/>
          <!-- ------------- -->

          <b-row>
            <b-col lg="12"><h4>Datos del Mes y Año:</h4></b-col>
            <b-col lg="3">
              <b-form-group label="Mes" label-for="mes">
                <validation-provider
                    #default="{ errors }"
                    name="Mes"
                    vid="mes"
                    rules="required"
                >
                  <v-select
                      id="mes"
                      v-model="mesSelected"
                      :options="meses"
                      :reduce="(meses) => meses.value"
                      label="text"
                      key="value"
                      placeholder="Seleccionar mes..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Año" label-for="anio">
                <validation-provider
                    #default="{ errors }"
                    name="Anio"
                    vid="anio"
                    rules=""
                >
                  <v-select
                      id="anio"
                      v-model="anio"
                      :options="anios"
                      placeholder="Seleccionar año .."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr/>
          <!-- ------------- -->
          <b-row>
            <b-col lg="12"><h4>Datos de Horarios:</h4></b-col>
            <b-col lg="3">
              <b-form-group label="Fecha" label-for="fecha">
                <validation-provider
                    #default="{ errors }"
                    name="Fecha"
                    vid="fecha"
                    rules=""
                >
                  <b-form-datepicker
                      id="fecha"
                      v-model="fecha"
                      :date-format-options="{
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    }"
                      :hide-header="true"
                      start-weekday="1"
                      v-bind="labels || {}"
                      today-button
                      reset-button
                      close-button
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Hora Inicio" label-for="hora_inicio">
                <validation-provider
                    #default="{ errors }"
                    name="Hora Inicio"
                    vid="hora_inicio"
                    rules=""
                >
                  <b-form-timepicker
                      id="hora_inicio"
                      v-model="hora_inicio"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Hora Fin" label-for="hora_fin">
                <validation-provider
                    #default="{ errors }"
                    name="Hora Fin"
                    vid="hora_fin"
                    rules=""
                >
                  <b-form-timepicker
                      id="hora_fin"
                      v-model="hora_fin"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                      @input="calcularRestaHoras"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Tiempo Estimado" label-for="total_horas">
                <validation-provider
                    #default="{ errors }"
                    name="Tiempo Estimado"
                    vid="total_horas"
                    rules=""
                >
                  <b-form-input
                      id="total_horas"
                      v-model="total_horas"
                      :state="errors.length > 0 ? false : null"
                      name="total_horas"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr/>
          <b-row>
            <b-col lg="12"><h4>Datos de Lugar:</h4></b-col>
            <b-col lg="3">
              <b-form-group label="Empresa" label-for="empresa">
                <validation-provider
                    #default="{ errors }"
                    name="Empresa"
                    vid="empresa"
                    rules=""
                >
                  <v-select
                      id="empresa"
                      v-model="empresa"
                      :options="empresas"
                      placeholder="Seleccionar empresa .."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Unidad" label-for="unidad">
                <validation-provider
                    #default="{ errors }"
                    name="Unidad"
                    vid="unidad"
                    rules=""
                >
                  <v-select
                      id="unidad"
                      v-model="unidad"
                      :options="unidads"
                      placeholder="Seleccionar unidad .."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Sede" label-for="sede">
                <validation-provider
                    #default="{ errors }"
                    name="Sede"
                    vid="sede"
                    rules=""
                >
                  <v-select
                      id="sede"
                      v-model="sede"
                      :options="sedes"
                      placeholder="Seleccionar sede .."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Área Usuaria" label-for="area_usuaria">
                <validation-provider
                    #default="{ errors }"
                    name="Área Usuaria"
                    vid="area_usuaria"
                    rules=""
                >
                  <v-select
                      id="area_usuaria"
                      v-model="area_usuaria"
                      :options="area_usuarias"
                      placeholder="Seleccionar area_usuaria .."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Departamento" label-for="departamento">
                <validation-provider
                    #default="{ errors }"
                    name="Departamento"
                    vid="departamento"
                    rules=""
                >
                  <v-select
                      id="departamento"
                      v-model="departamento"
                      :options="departamentos"
                      placeholder="Seleccionar departamento .."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Área" label-for="area">
                <validation-provider
                    #default="{ errors }"
                    name="Área"
                    vid="area"
                    rules=""
                >
                  <v-select
                      id="area"
                      v-model="area"
                      :options="areas"
                      placeholder="Seleccionar área .."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Sección" label-for="seccion">
                <validation-provider
                    #default="{ errors }"
                    name="Sección"
                    vid="seccion"
                    rules=""
                >
                  <v-select
                      id="seccion"
                      v-model="seccion"
                      :options="seccions"
                      placeholder="Seleccionar sección .."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Zona" label-for="zona">
                <validation-provider
                    #default="{ errors }"
                    name="Zona"
                    vid="zona"
                    rules=""
                >
                  <!--
                  <v-select
                      id="zona"
                      v-model="zona"
                      :options="zonas"
                      placeholder="Seleccionar zona .."
                  />
                  -->
                  <b-form-input
                      id="zona"
                      v-model="zona"
                      :state="errors.length > 0 ? false : null"
                      name="zona"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Cultivo" label-for="cultivo">
                <validation-provider
                    #default="{ errors }"
                    name="Cultivo"
                    vid="cultivo"
                    rules=""
                >
                  <v-select
                      id="cultivo"
                      v-model="cultivo"
                      :options="cultivos"
                      placeholder="Seleccionar cultivo .."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr/>
          <b-row>
            <b-col lg="12"><h4>Detalles:</h4></b-col>
            <b-col lg="3">
              <b-form-group label="Actividad" label-for="actividad">
                <validation-provider
                    #default="{ errors }"
                    name="Actividad"
                    vid="actividad"
                    rules=""
                >
                  <v-select
                      id="actividad"
                      v-model="actividad"
                      :options="actividads"
                      placeholder="Seleccionar actividad .."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Modelo" label-for="modelo">
                <validation-provider
                    #default="{ errors }"
                    name="Modelo"
                    vid="modelo"
                    rules=""
                >
                  <v-select
                      id="modelo"
                      v-model="modelo"
                      :options="modelos"
                      placeholder="Seleccionar modelo .."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Modalidad" label-for="modalidad">
                <validation-provider
                    #default="{ errors }"
                    name="Modalidad"
                    vid="modalidad"
                    rules=""
                >
                  <v-select
                      id="modalidad"
                      v-model="modalidad"
                      :options="modalidads"
                      placeholder="Seleccionar modalidad .."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Escuela" label-for="escuela">
                <validation-provider
                    #default="{ errors }"
                    name="Escuela"
                    vid="escuela"
                    rules=""
                >
                  <v-select
                      id="escuela"
                      v-model="escuela"
                      :options="escuelas"
                      placeholder="Seleccionar escuela .."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Categoría" label-for="categoria">
                <validation-provider
                    #default="{ errors }"
                    name="Categoría"
                    vid="categoria"
                    rules=""
                >
                  <v-select
                      id="categoria"
                      v-model="categoria"
                      :options="categorias"
                      placeholder="Seleccionar categoria .."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                  label="Área Responsable"
                  label-for="area_responsable"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Área Responsable"
                    vid="area_responsable"
                    rules=""
                >
                  <v-select
                      id="area_responsable"
                      v-model="area_responsable"
                      :options="area_responsables"
                      placeholder="Seleccionar area responsable .."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Tipo" label-for="tipo">
                <validation-provider
                    #default="{ errors }"
                    name="Tipo"
                    vid="tipo"
                    rules=""
                >
                  <v-select
                      id="tipo"
                      v-model="tipo"
                      :options="tipos"
                      placeholder="Seleccionar tipo .."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr/>
          <b-row>
            <b-col lg="12"><h4>Material:</h4></b-col>

            <b-col lg="4">
              <b-form-group label="Código del Material" label-for="codigo_material">
                <validation-provider
                    #default="{ errors }"
                    name="Código del Material"
                    vid="codigo_material"
                    rules="required"
                >
                  <b-form-input
                      id="codigo_material"
                      v-model="codMaterial"
                      :state="errors.length > 0 ? false : null"
                      name="codigo_material"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="8">
              <b-form-group label="Documento" label-for="documento">
                <validation-provider
                    #default="{ errors }"
                    name="Documento"
                    vid="documento"
                    rules="required"
                >
                  <b-form-file
                      id="documento"
                      v-model="material"
                      placeholder="Carga tu documento aquí..."
                      drop-placeholder="Carga tu documento aquí..."
                      :state="errors.length > 0 ? false : null"
                      name="documento"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>



        </b-form>
      </validation-observer>
    </b-modal>
    <!-- ------MODAL IMPORTAR----- -->
    <b-modal
        id="modal-importar"
        ref="modal_importar"
        title="Importar Datos Masivos"
        ok-title="Importar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        size="md"
        :cancel-disabled="loadingCarga"
        :ok-disabled="loadingCarga || !archivo_excel"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        @ok="importarOk"
    >
      <div v-if="loadingCarga" align="center">
        <p>Importando datos ...</p>
        <b-spinner label="Importando ..." variant="primary"/>
      </div>
      <validation-observer
          v-else
          ref="formularioImportarTemas"
          #default="{ invalid }"
      >
        <b-form autocomplete="off" @submit.prevent="enviarExcelMasivos">
          <b-row>
            <b-col lg="12">
              <b-form-group label="Archivo" label-for="archivo">
                <validation-provider
                    #default="{ errors }"
                    name="Archivo"
                    vid="archivo"
                    rules=""
                >
                  <b-form-file
                      id="archivo"
                      accept=".xlsx"
                      placeholder="Seleccionar Archivo Excel (.xlsx)"
                      v-model="archivo_excel"
                      ref="fileinput"
                  >
                    <template slot="file-name" slot-scope="{ names }">
                      <b-badge variant="primary">
                        {{ names[0] }}
                      </b-badge>
                    </template>
                  </b-form-file>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>
    <!-- -----MODAL EDITAR--- -->
    <b-modal
        id="modal_editar"
        ref="modal_editar"
        v-model="mostrarModalEditar"
        title="Editar Tema"
        ok-title="Editar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        :size="loadingEditar ? 'md' : 'xl'"
        :cancel-disabled="loadingEditar"
        :ok-disabled="loadingEditar"
        :centered="loadingEditar"
        scrollable
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden="resetModal"
        @ok="validarRegistroEditar"
    >
      <div v-if="loadingEditar" align="center">
        <p>Editando ...</p>
        <b-spinner label="Editando ..." variant="primary"/>
      </div>
      <validation-observer
          v-else
          ref="formularioTemasEditar"
          #default="{ invalid }"
      >
        <b-form autocomplete="off" @submit.prevent="editarTema">
          <b-row>
            <b-col lg="12"><h4>Datos del Tema:</h4></b-col>
            <b-col lg="5">
              <b-form-group label="Nombre del Tema" label-for="e_tema">
                <validation-provider
                    #default="{ errors }"
                    name="Nombre del Tema"
                    vid="tema"
                    rules="required"
                >
                  <b-form-input
                      id="e_tema"
                      v-model="tema"
                      :state="errors.length > 0 ? false : null"
                      name="tema"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="7">
              <b-form-group label="Temario" label-for="e_temario">
                <validation-provider
                    #default="{ errors }"
                    name="Temario"
                    vid="temario"
                    rules=""
                >
                  <b-form-input
                      id="e_temario"
                      v-model="temario"
                      :state="errors.length > 0 ? false : null"
                      name="temario"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Objetivo" label-for="e_objetivo">
                <validation-provider
                    #default="{ errors }"
                    name="Objetivo"
                    vid="objetivo"
                    rules=""
                >
                  <b-form-input
                      id="e_objetivo"
                      v-model="objetivo"
                      :state="errors.length > 0 ? false : null"
                      name="objetivo"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Código" label-for="e_codigo">
                <validation-provider
                    #default="{ errors }"
                    name="Código"
                    vid="e_codigo"
                    rules=""
                >
                  <b-form-input
                      id="e_codigo"
                      v-model="codigo"
                      :state="errors.length > 0 ? false : null"
                      name="codigo"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Grupo Objetivo" label-for="e_planilla">
                <validation-provider
                    #default="{ errors }"
                    name="Grupo Objetivo"
                    vid="planilla"
                    rules=""
                >
                  <b-form-input
                      id="e_planilla"
                      v-model="planilla"
                      :state="errors.length > 0 ? false : null"
                      name="planilla"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Participantes" label-for="e_participantes">
                <validation-provider
                    #default="{ errors }"
                    name="Participantes"
                    vid="participantes"
                    rules=""
                >
                  <b-form-input
                      id="e_participantes"
                      v-model="participantes"
                      :state="errors.length > 0 ? false : null"
                      name="participantes"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group
                  label="Código del material"
                  label-for="e_cod_material"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Código del material"
                    vid="cod_material"
                    rules=""
                >
                  <b-form-input
                      id="e_cod_material"
                      v-model="cod_material"
                      :state="errors.length > 0 ? false : null"
                      name="cod_material"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr/>
          <b-row>
            <b-col lg="12"><h4>Datos de Expositor:</h4></b-col>
            <b-col lg="2">
              <b-form-group label="DNI Expositor" label-for="e_dni_expositor">
                <validation-provider
                    #default="{ errors }"
                    name="DNI"
                    vid="dni_expositor"
                    rules=""
                >
                  <b-form-input
                      id="e_dni_expositor"
                      v-model="dni_expositor"
                      :state="errors.length > 0 ? false : null"
                      name="dni_expositor"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Nombre Expositor" label-for="e_expositor">
                <validation-provider
                    #default="{ errors }"
                    name="Nombre Expositor"
                    vid="expositor"
                    rules=""
                >
                  <b-form-input
                      id="e_expositor"
                      v-model="expositor"
                      :state="errors.length > 0 ? false : null"
                      name="expositor"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                  label="Procedencia"
                  label-for="e_procedencia_expositor"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Procedencia"
                    vid="procedencia_expositor"
                    rules=""
                >
                  <b-form-input
                      id="e_procedencia_expositor"
                      v-model="procedencia_expositor"
                      :state="errors.length > 0 ? false : null"
                      name="procedencia_expositor"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr/>
          <!-------------i -->
          <b-row>
            <b-col lg="12"><h4>Datos del Mes y Año:</h4></b-col>
            <b-col lg="3">
              <b-form-group label="Mes" label-for="mes">
                <validation-provider
                    #default="{ errors }"
                    name="Mes"
                    vid="mes"
                    rules="required"
                >
                  <v-select
                      id="mes"
                      v-model="mesSelected"
                      :options="meses"
                      :reduce="(meses) => meses.value"
                      label="text"
                      key="value"
                      placeholder="Seleccionar mes..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Año" label-for="anio">
                <validation-provider
                    #default="{ errors }"
                    name="Anio"
                    vid="anio"
                    rules=""
                >
                  <b-form-input
                      id="anio"
                      v-model="anio"
                      :state="errors.length > 0 ? false : null"
                      name="anio"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr/>
          <!-- -----------f -->
          <b-row>
            <b-col lg="12"><h4>Datos de Horarios:</h4></b-col>
            <b-col lg="3">
              <b-form-group label="Fecha" label-for="e_fecha">
                <validation-provider
                    #default="{ errors }"
                    name="Fecha"
                    vid="fecha"
                    rules=""
                >
                  <b-form-datepicker
                      id="e_fecha"
                      v-model="fecha"
                      :date-format-options="{
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    }"
                      :hide-header="true"
                      start-weekday="1"
                      v-bind="labels || {}"
                      today-button
                      reset-button
                      close-button
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Hora Inicio" label-for="e_hora_inicio">
                <validation-provider
                    #default="{ errors }"
                    name="Hora Inicio"
                    vid="hora_inicio"
                    rules=""
                >
                  <b-form-timepicker
                      id="e_hora_inicio"
                      v-model="hora_inicio"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Hora Fin" label-for="e_hora_fin">
                <validation-provider
                    #default="{ errors }"
                    name="Hora Fin"
                    vid="hora_fin"
                    rules=""
                >
                  <b-form-timepicker
                      id="e_hora_fin"
                      v-model="hora_fin"
                      v-bind="espanol"
                      now-button
                      reset-button
                      locale="en"
                      @input="calcularRestaHoras"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Tiempo Estimado" label-for="e_total_horas">
                <validation-provider
                    #default="{ errors }"
                    name="Tiempo Estimado"
                    vid="total_horas"
                    rules=""
                >
                  <b-form-input
                      id="e_total_horas"
                      v-model="total_horas"
                      :state="errors.length > 0 ? false : null"
                      name="total_horas"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr/>
          <b-row>
            <b-col lg="12"><h4>Datos de Lugar:</h4></b-col>
            <b-col lg="3">
              <b-form-group label="Empresa" label-for="e_empresa">
                <validation-provider
                    #default="{ errors }"
                    name="Empresa"
                    vid="empresa"
                    rules=""
                >
                  <b-form-input
                      id="e_empresa"
                      v-model="empresa"
                      :state="errors.length > 0 ? false : null"
                      name="empresa"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Unidad" label-for="e_unidad">
                <validation-provider
                    #default="{ errors }"
                    name="Unidad"
                    vid="unidad"
                    rules=""
                >
                  <b-form-input
                      id="e_unidad"
                      v-model="unidad"
                      :state="errors.length > 0 ? false : null"
                      name="unidad"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Sede" label-for="e_sede">
                <validation-provider
                    #default="{ errors }"
                    name="Sede"
                    vid="sede"
                    rules=""
                >
                  <b-form-input
                      id="e_sede"
                      v-model="sede"
                      :state="errors.length > 0 ? false : null"
                      name="sede"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Área Usuaria" label-for="e_area_usuaria">
                <validation-provider
                    #default="{ errors }"
                    name="Área Usuaria"
                    vid="area_usuaria"
                    rules=""
                >
                  <b-form-input
                      id="e_area_usuaria"
                      v-model="area_usuaria"
                      :state="errors.length > 0 ? false : null"
                      name="area_usuaria"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Departamento" label-for="e_departamento">
                <validation-provider
                    #default="{ errors }"
                    name="Departamento"
                    vid="departamento"
                    rules=""
                >
                  <b-form-input
                      id="e_departamento"
                      v-model="departamento"
                      :state="errors.length > 0 ? false : null"
                      name="departamento"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Área" label-for="e_area">
                <validation-provider
                    #default="{ errors }"
                    name="Área"
                    vid="area"
                    rules=""
                >
                  <b-form-input
                      id="e_area"
                      v-model="area"
                      :state="errors.length > 0 ? false : null"
                      name="area"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Sección" label-for="e_seccion">
                <validation-provider
                    #default="{ errors }"
                    name="Sección"
                    vid="seccion"
                    rules=""
                >
                  <b-form-input
                      id="e_seccion"
                      v-model="seccion"
                      :state="errors.length > 0 ? false : null"
                      name="seccion"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Zona" label-for="e_zona">
                <validation-provider
                    #default="{ errors }"
                    name="Zona"
                    vid="zona"
                    rules=""
                >
                  <b-form-input
                      id="e_zona"
                      v-model="zona"
                      :state="errors.length > 0 ? false : null"
                      name="zona"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Cultivo" label-for="e_cultivo">
                <validation-provider
                    #default="{ errors }"
                    name="Cultivo"
                    vid="cultivo"
                    rules=""
                >
                  <b-form-input
                      id="e_cultivo"
                      v-model="cultivo"
                      :state="errors.length > 0 ? false : null"
                      name="cultivo"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr/>
          <b-row>
            <b-col lg="12"><h4>Detalles:</h4></b-col>
            <b-col lg="2">
              <b-form-group label="Actividad" label-for="e_actividad">
                <validation-provider
                    #default="{ errors }"
                    name="Actividad"
                    vid="actividad"
                    rules=""
                >
                  <b-form-input
                      id="e_actividad"
                      v-model="actividad"
                      :state="errors.length > 0 ? false : null"
                      name="actividad"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Modalidad" label-for="e_modalidad">
                <validation-provider
                    #default="{ errors }"
                    name="Modalidad"
                    vid="modalidad"
                    rules=""
                >
                  <b-form-input
                      id="e_modalidad"
                      v-model="modalidad"
                      :state="errors.length > 0 ? false : null"
                      name="modalidad"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Escuela" label-for="e_escuela">
                <validation-provider
                    #default="{ errors }"
                    name="Escuela"
                    vid="escuela"
                    rules=""
                >
                  <b-form-input
                      id="e_escuela"
                      v-model="escuela"
                      :state="errors.length > 0 ? false : null"
                      name="escuela"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Categoría" label-for="e_categoria">
                <validation-provider
                    #default="{ errors }"
                    name="Categoría"
                    vid="categoria"
                    rules=""
                >
                  <b-form-input
                      id="e_categoria"
                      v-model="categoria"
                      :state="errors.length > 0 ? false : null"
                      name="categoria"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Área Responsable"
                  label-for="e_area_responsable"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Área Responsable"
                    vid="area_responsable"
                    rules=""
                >
                  <b-form-input
                      id="e_area_responsable"
                      v-model="area_responsable"
                      :state="errors.length > 0 ? false : null"
                      name="area_responsable"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal
        id="modalVerLink"
        v-model="verLink"
        ok-title="Aceptar"
        ok-only
        title="Link"
        scrollable
    >
      <b-row>
        <b-col lg="12">
          <a target="_blank" :href="link">{{ link }}</a>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
        id="modalMaterial"
        ref="modal_material"
        v-model="verModalMaterial"
        ok-title="Aceptar"
        ok-only
        title="Registrar Material"
        scrollable
        @ok="validarRegistroMaterial"
    >
      <div v-if="loadingMaterial" align="center">
        <p>Registrando ...</p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <b-row v-else>
        <b-col lg="12">
          <p><b>Tema: {{ temaMaterial }}</b></p>
          <validation-observer ref="formularioMaterial" #default="{ invalid }">
            <b-form autocomplete="off" @submit.prevent="registrarMaterial">
              <b-row>
                <b-col lg="12">
                  <b-form-group label="Código del Material" label-for="codigo_material_r">
                    <validation-provider
                        #default="{ errors }"
                        name="Código del Material"
                        vid="codigo_material_r"
                        rules="required"
                    >
                      <b-form-input
                          id="codigo_material_r"
                          v-model="codMaterial"
                          :state="errors.length > 0 ? false : null"
                          name="codigo_material_r"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col lg="12">
                  <b-form-group label="Documento" label-for="documento_r">
                    <validation-provider
                        #default="{ errors }"
                        name="Documento"
                        vid="documento_r"
                        rules="required"
                    >
                      <b-form-file
                          id="documento_r"
                          v-model="material"
                          placeholder="Carga tu documento aquí..."
                          drop-placeholder="Carga tu documento aquí..."
                          :state="errors.length > 0 ? false : null"
                          name="documento_r"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import axiosIns from '../../libs/axios'
import vSelect from 'vue-select'
import { HotTable } from '@handsontable/vue'
import { registerAllModules } from 'handsontable/registry'
import { esMX, registerLanguageDictionary } from 'handsontable/i18n'

import {
  BBadge,
  BButton,
  BButtonGroup,
  BCard,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BModal,
  BPagination,
  BSpinner,
  BTable,
  BRow,
  BCol,
  BDropdownDivider,
  BTooltip,
  BInputGroupAppend,
  BInputGroup,
  BFormFile,
  BFormDatepicker,
  BFormTimepicker,
  BDropdown,
  BDropdownForm,
  BDropdownItem,
  BDropdownHeader,
  VBTooltip,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import flatPickr from 'vue-flatpickr-component'
import { Spanish } from 'flatpickr/dist/l10n/es.js'

registerAllModules()
registerLanguageDictionary(esMX)

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BButtonGroup,
    BFormInput,
    BModal,
    BForm,
    BCol,
    BRow,
    BDropdownDivider,
    BTooltip,
    BInputGroup,
    BInputGroupAppend,
    BFormFile,
    BFormDatepicker,
    BFormTimepicker,
    BDropdown,
    BDropdownForm,
    BDropdownItem,
    BDropdownHeader,
    flatPickr,

    vSelect,

    ValidationProvider,
    ValidationObserver,
    HotTable,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data: () => ({
    loading: false,
    loadingCarga: false,
    loading2: false,
    loadingMaterial: false,
    loadingEditar: false,
    loadingExcel: false,
    loadingMasivo: false,
    loadingMasivoEditar: false,
    mostrarModalEditar: false,
    perPage: 15,
    pageOptions: [5, 10, 15],
    totalRows: 0,
    currentPage: 1,
    items: [],
    sortBy: 'id',
    sortDesc: true,
    sortDirection: 'desc',
    filter: null,
    // filterOn: ['dni_expositor', 'expositor', 'area_usuaria', 'departamento', 'area', 'seccion', 'zona', 'cultivo'],
    filterOn: ['tema'],
    status: [
      {
        0: 'Pendiente',
        1: 'En Proceso',
        3: 'Realizado',
        4: 'Deshabilitado',
      },
      {
        0: 'light-warning',
        1: 'light-info',
        3: 'light-success',
        4: 'light-danger',
      },
    ],
    meses: [
      {
        value: '01',
        text: 'ENERO'
      },
      {
        value: '02',
        text: 'FEBRERO'
      },
      {
        value: '03',
        text: 'MARZO'
      },
      {
        value: '04',
        text: 'ABRIL'
      },
      {
        value: '05',
        text: 'MAYO'
      },
      {
        value: '06',
        text: 'JUNIO'
      },
      {
        value: '07',
        text: 'JULIO'
      },
      {
        value: '08',
        text: 'AGOSTO'
      },
      {
        value: '09',
        text: 'SETIEMBRE'
      },
      {
        value: '10',
        text: 'OCTUBRE'
      },
      {
        value: '11',
        text: 'NOVIEMBRE'
      },
      {
        value: '12',
        text: 'DICIEMBRE'
      },
    ],
    meses_list_select: null,
    meses_list: [],

    planillas: [
      'OBREROS',
      'EMPLEADOS',
      'OBREROS Y EMPLEADOS',
      'OBREROS CALIFICADOS Y EMPLEADOS',
      'OBREROS Y OBREROS CALIFICADOS',
    ],

    procedencias_expositor: ['AGROVISION PERU SAC', 'ARENA VERDE SAC'],

    anios: ['2024', '2023', '2022'],

    empresas: ['AGROVISION', 'ARENA VERDE'],

    unidads: ['AGRÍCOLA', 'INDUSTRIAL'],

    sedes: [
      'OLMOS C5',
      'OLMOS A9',
      'OLMOS B1',
      'CARHUAZ',
      'CAJAMARCA',
      'CHICLAYO',
      'LIMA',
      'LOTE NORTE',
      'LOTE CENTRO',
      'LOTE SAN RICARDO',
      'CAMPAMENTO',
    ],

    area_usuarias: [
      'ADMINISTRACIÓN',
      'BIENESTAR SOCIAL',
      'FOOD SAFETY',
      'GESTIÓN HUMANA',
      'GESTIÓN Y DESARROLLO HUMANO',
      'MANEJO INTEGRADO DE PLAGAS',
      'SALUD OCUPACIONAL',
      'SEGURIDAD PATRIMONIAL',
      'SEGURIDAD Y SALUD EN EL TRABAJO',
      'COSECHA',
    ],

    departamentos: [
      'ADMINISTRACIÓN Y ASUNTOS CORPORATIVOS',
      'INNOVACIÓN Y NUEVOS NEGOCIOS',
      'FINANZAS',
      'SERVICIOS Y DESARROLLO AGRÍCOLA',
      'OPERACIONES AGRÍCOLAS',
      'GESTIÓN HUMANA',
      'COMITÉ SST',
      'GRUPO EFI',
      'VARIOS',
      'BRIGADISTAS DE CAMPO',
    ],

    areas: [
      'ADMINISTRACIÓN Y ASUNTOS CORPORATIVOS',
      'ADMINISTRACIÓN DE FUNDO',
      'SEGURIDAD PATRIMONIAL',
      'INNOVACIÓN Y NUEVOS NEGOCIOS',
      'ASEGURAMIENTO DE LA CALIDAD',
      'INVESTIGACIÓN Y DESARROLLO',
      'MANEJO INTEGRADO DE PLAGAS',
      'AGRICULTURA DE PRECISIÓN',
      'FINANZAS',
      'LOGÍSTICA',
      'TECNOLOGÍA DE LA INFORMACIÓN',
      'SERVICIOS Y DESARROLLO AGRÍCOLA',
      'GESTIÓN HUMANA',
      'SOPORTE OPERATIVO',
      'OPERACIONES AGRÍCOLAS',
      'UN ARÁNDANO',
      'UN ESPÁRRAGO',
      'UN VID',
      'UN PALTA',
      'UN LIMÓN',
      'PLANIFICACIÓN Y CONTROL DE GESTIÓN AGRÍCOLA',
      'GESTIÓN DE LA INFORMACIÓN',
      'PACKING',
      'COMITÉ SST',
      'GRUPO EFI',
      'BRIGADISTAS DE CAMPO',
      'ASUNTOS CORPORATIVOS Y SOSTENIBILIDAD',
      'PRODUCCION DE ALIMENTOS',
      'MEJORA CONTINUA',
      'RELACIONES COMUNITARIAS',
    ],

    seccions: [
      'ADMINISTRACIÓN Y ASUNTOS CORPORATIVOS',
      'ADMINISTRACIÓN',
      'CASA HACIENDA',
      'COMEDOR',
      'FORESTAL',
      'MANTENIMIENTO CAMPAMENTO',
      'SEGURIDAD PATRIMONIAL',
      'INNOVACIÓN Y NUEVOS NEGOCIOS',
      'ASEGURAMIENTO DE LA CALIDAD',
      'FOOD SAFETY',
      'CALIDAD Y POSCOSECHA',
      'CONTROL DE PROCESOS',
      'LABORATORIO',
      'INVESTIGACIÓN Y DESARROLLO',
      'AGRICULTURA DE PRECISIÓN',
      'FINANZAS',
      'LOGÍSTICA',
      'ALMACENES',
      'TECNOLOGÍA DE LA INFORMACIÓN',
      'SERVICIOS Y DESARROLLO AGRÍCOLA',
      'RIEGO Y FERTILIZACIÓN',
      'MO Y MAQUINARIA',
      'MANEJO INTEGRADO DE PLAGAS',
      'MANTENIMIENTO AGRÍCOLA',
      'GESTIÓN HUMANA',
      'PLANNER',
      'ADM. PERSONAL Y COMPENSACIONES',
      'GESTIÓN Y DESARROLLO HUMANO',
      'RECLUTAMIENTO Y RETENCIÓN',
      'GESTIÓN HUMANA / SOPORTE OPERACIONES',
      'CAMPO',
      'SEGURIDAD Y SALUD EN EL TRABAJO',
      'BIENESTAR SOCIAL',
      'TRANSPORTE',
      'CCC',
      'SOPORTE OPERATIVO',
      'OPERACIONES AGRÍCOLAS',
      'UN ARÁNDANO',
      'FITOSANIDAD',
      'PRODUCCIÓN',
      'GESTIÓN E INVESTIGACIÓN AGRÍCOLA',
      'COSECHA',
      'UN ESPÁRRAGO',
      'UN VID',
      'FENOLOGÍA',
      'UN PALTA',
      'PLANIFICACIÓN Y CONTROL DE OPERACIONES AGRÍCOLA',
      'MAQUINARIA ARÁNDANO',
      'RIEGO Y SERVICIOS AGRÍCOLAS',
      'PRODUCCIÓN / ALMACENES',
      'PRODUCCIÓN / MANTENIMIENTO',
      'PRODUCCIÓN / ACOPIO',
      'PRODUCCIÓN / FRÍO',
      'PRODUCCIÓN / INOCUIDAD Y BPM',
      'PRODUCCIÓN / EMPAQUE',
      'PACKING',
      'PRODUCCIÓN (APICULTURA Y CARPINTERIA)',
      'CAMPAMENTO',
      'SERVICIOS DE ALIMENTACIÓN',
      'COMPRAS',
      'COSECHA (TRANSPORTE DE MATERIA PRIMA)',
      'RIEGO Y FERTILIZACION ARÁNDANO',
      'COMITÉ SST',
      'GRUPO EFI',
      'CONSTRUCCIÓN Y OBRAS CIVILES',
      'PLANTA DE AGUA',
      'RIEGO SERVICIOS AGRÍCOLAS',
      'RIEGO SERVICIOS AGRICOLAS(MANTENIMIENTO)',
      'BRIGADISTAS DE CAMPO',
      'MEDIO AMBIENTE',
      'PLANIFICACIÓN Y CONTROL DE GESTIÓN AGRÍCOLA',
      'PROCESOS Y DATA',
      'ANALÍTICA DE DATOS Y BI',
      'PRODUCCIÓN/MANTENIMIENTO (MÉC,.ELÉC.FRIG.SS.GG)',
      'PRODUCCIÓN/MANTENIMIENTO (MÉC,.ELÉC.FRIG.SS.GG. BRIG.)',
      'PRODUCCIÓN/MANTENIMIENTO (ELÉC.FRIG.)',
      'PRODUCCIÓN/MANTENIMIENTO (SS:GG)',
      'PRODUCCIÓN/MANTENIMIENTO (MÉC,.ELÉC.FRIG.)',
      'PRODUCCIÓN/MANTENIMIENTO (OP. DE MONTA, P.ELEV)',
      'PRODUCCIÓN/MANTEMIENTO (SS:GG. FRIG)',
      'PRODUCCIÓN/MANTENIMIENTO (FRIGORISTA)',
      'PRODUCCIÓN / ALMACÉN (OP /BRIG)',
      'PRODUCCIÓN / ALMACÉN (OP. MONTA)',
      'PRODUCCIÓN / INOCUIDAD Y BPM (OP/ BRIG)',
      'PRODUCCIÓN / INOCUIDAD Y BPM (OP. PLAT. ELEV)',
      'PRODUCCIÓN / FRIO (OP / BRIG)',
      'PRODUCCIÓN / FRIO (OP.MONTA, TRANSPALLET)',
      'PRODUCCIÓN /ACOPIO (OP. MONTA)',
      'PRODUCCIÓN /ACOPIO (RECEPCIÓN MP)',
      'PRODUCCIÓN /ACOPIO (RECEPCIÓN MP/ BRIG)',
      'PRODUCCIÓN / ACOPIO (LAVADO DE JABAS)',
      'PRODUCCIÓN / ACOPIO - PRE FRÍO',
      'PRODUCCIÓN / ACOPIO - GASIFICADO',
      'PRODUCCIÓN / ACOPIO - GASIFICADO (OP / BRIG)',
      'PACKING (OP/ BRIG)',
      'PRODUCCIÓN / EMPAQUE ARÁNDANO (PLAN. DIG.ADM)',
      'PRODUCCIÓN / EMPAQUE ARÁNDANO (PLAN. DIG.ADM. BRIG)',
      'PRODUCCIÓN / EMPAQUE UVA (PLAN. DIG.ADM)',
      'PRODUCCIÓN / EMPAQUE PALTO (PLAN. DIG.ADM)',
      'PRODUCCIÓN / EMPAQUE ESPÁRRAGO(PLAN. DIG.ADM)',
      'ASEGURAMIENTO DE LA CALIDAD (OP/BRIG)',
      'PRODUCCIÓN /GESTIÓN DE PROCESOS',
      'CALIDAD',
      'PLANIFICACIÓN',
      'PRODUCCIÓN ( BRIGADISTAS)',
      'RIEGO Y FERTILIZACIÓN ( BRIGADISTAS)',
      'PRODUCCIÓN (BRIGADISTAS)',
      'PRODUCCION / EMPAQUE (BRIGADISTAS)',
      'PRODUCCION / ACOPIO (BRIGADISTAS)',
      'PRODUCCION / FRIO (BRIGADISTAS)',
      'PRODUCCION / MANTENIMIENTO (BRIGADISTAS)',
      'PRODUCCION / INOCUIDAD Y BPM (BRIGADISTAS)',
      'PRODUCCION / GESTION DE PROCESOS',
      'PRODUCCION DE ALIMENTOS',
      'LEAN Y MEJORA CONTINUA',
      'OFICINAS ADMINISTRATIVAS',
      'RRHH',
      'CERCO PERIMETRAL',
      'RELACIONES COMUNITARIAS',
      'REFORESTACIÓN',
    ],

    zonas: [],

    cultivos: [
      'TRANSVERSAL',
      'UN CEREZA',
      'UN ARÁNDANO',
      'UN ESPÁRRAGO',
      'UN VID',
      'UN PALTA',
      'UN LIMÓN',
    ],

    actividads: [
      'INDUCCIÓN',
      'CAPACITACIÓN',
      'ENTRENAMIENTO',
      'SIMULACRO',
      'CHARLA',
    ],

    modalidads: ['INTERNA', 'INHOUSE'],

    escuelas: [
      'SISTEMA INTEGRADO DE GESTIÓN',
      'TÉCNICA',
      'GESTIÓN Y LIDERAZGO',
      'OTROS',
    ],

    categorias: [
      'SEGURIDAD Y SALUD EN EL TRABAJO',
      'BRC/IFS',
      'GLOBAL GAP',
      'BASC',
      'FSMA',
      'BPM',
      'HACCP',
      'GESTIÓN AMBIENTAL',
      'RESPONSABILIDAD SOCIAL',
      'PROCESO TÉCNICO',
      'OTROS',
    ],

    area_responsables: [
      'ACOPIO',
      'ADMINISTRACIÓN',
      'ALMACÉN',
      'ASEGURAMIENTO DE LA CALIDAD',
      'AUDITORÍA INTERNA',
      'CONSTRUCCIÓN Y OBRAS CIVILES',
      'BIENESTAR SOCIAL',
      'EMPAQUE',
      'FITOSANIDAD',
      'FOOD SAFETY',
      'FRÍO',
      'GESTIÓN HUMANA',
      'GESTIÓN Y DESARROLLO HUMANO',
      'INOCUIDAD Y BPM',
      'INVESTIGACIÓN Y DESARROLLO',
      'MANTENIMIENTO',
      'MANEJO INTEGRADO DE PLAGAS',
      'MO Y MAQUINARIA',
      'PRODUCCIÓN DE ALIMENTOS',
      'RECLUTAMIENTO Y RETENCIÓN',
      'SALUD OCUPACIONAL',
      'SEGURIDAD Y SALUD EN EL TRABAJO',
      'TRANSPORTES',
    ],

    tipos: ['PRESENCIAL', 'VIRTUAL'],

    modelos: ['CERTIFICACIONES', 'ECA'],

    modelo: null,

    tema: null,
    temario: null,
    objetivo: null,
    codigo: null,
    planilla: null,
    participantes: null,
    cod_material: null,

    dni_expositor: null,
    expositor: null,
    procedencia_expositor: null,

    fecha: null,
    hora_inicio: null,
    hora_fin: null,
    total_horas: null,

    empresa: null,
    unidad: null,
    sede: null,
    area_usuaria: null,
    departamento: null,
    area: null,
    seccion: null,
    zona: null,
    cultivo: null,

    actividad: null,
    modalidad: null,
    escuela: null,
    categoria: null,
    area_responsable: null,
    tipo: null,

    materialRegistro: null,
    materialCod: null,

    mes: null,
    anio: null,
    mesSelected: null,

    estado: null,

    archivo_excel: null,

    id_editar: null,

    labels: {
      labelPrevDecade: 'Década anterior',
      labelPrevYear: 'Año anterior',
      labelPrevMonth: 'Mes anterior',
      labelCurrentMonth: 'Mes actual',
      labelNextMonth: 'Mes siguiente',
      labelNextYear: 'Año siguiente',
      labelNextDecade: 'Década siguiente',
      labelToday: 'Hoy',
      labelSelected: 'Fecha seleccionada',
      labelNoDateSelected: 'Seleccione fecha',
      labelCalendar: 'Calendario',
      labelNav: 'Navegación por calendario',
      labelHelp: 'Use las teclas de flecha para navegar por el calendario',
      labelTodayButton: 'Hoy',
      labelResetButton: 'Borrar',
      labelCloseButton: 'Cerrar',
    },
    espanol: {
      labelHours: 'Hora',
      labelMinutes: 'Minuto',
      labelSeconds: 'Segundos',
      labelIncrement: 'Erhöhen',
      labelDecrement: 'Verringern',
      labelSelected: 'Ausgewählte Zeit',
      labelNoTimeSelected: 'Seleccione Hora',
      labelCloseButton: 'Cerrar',
      labelResetButton: 'Borrar',
      labelNowButton: 'Ahora',
    },

    itemsFiltro: [],

    filtro: [
      {
        nombre: 'empresa',
        valor: []
      },
      {
        nombre: 'sede',
        valor: []
      },
      {
        nombre: 'unidad',
        valor: []
      },
      {
        nombre: 'tema',
        valor: []
      },
      {
        nombre: 'actividad',
        valor: []
      },
      {
        nombre: 'categoria',
        valor: []
      },
      {
        nombre: 'seccion',
        valor: []
      },
      {
        nombre: 'area_responsable',
        valor: []
      },
      {
        nombre: 'fecha',
        valor: []
      },
    ],

    empresaFiltro: [],
    sedeFiltro: [],
    unidadFiltro: [],
    temaFiltro: [],
    actividadFiltro: [],
    categoriaFiltro: [],
    seccionFiltro: [],
    area_responsableFiltro: [],

    empresa_filtro: [],
    sede_filtro: [],
    unidad_filtro: [],
    tema_filtro: [],
    actividad_filtro: [],
    categoria_filtro: [],
    seccion_filtro: [],
    area_responsable_filtro: [],

    fechaFiltro: null,
    link: null,
    verLink: false,

    tabla: null,
    settings: null,

    columnas: {
      id: 0,
      estado: 1,
      tipo_capacitacion: 2,
      modelo: 3,
      codigo: 4,
      tema: 5,
      temario: 6,
      objetivo: 7,
      planilla: 8,
      participantes: 9,
      cod_material: 10,
      dni_expositor: 11,
      expositor: 12,
      procedencia_expositor: 13,
      fecha: 14,
      hora_inicio: 15,
      hora_fin: 16,
      total_horas: 17,
      empresa: 18,
      unidad: 19,
      sede: 20,
      area_usuaria: 21,
      departamento: 22,
      area: 23,
      seccion: 24,
      zona: 25,
      cultivo: 26,
      actividad: 27,
      modalidad: 28,
      escuela: 29,
      categoria: 30,
      area_responsable: 31,
      mes_anio: 32,
    },

    arrayEditar: [],
    loadingSave: false,

    verModalMaterial: false,
    idMaterial: false,
    codMaterial: null,
    temaMaterial: null,
    material: null,

    // validation rules
    required,
  }),
  computed: {},
  mounted() {
    const yo = this
    yo.tabla = yo.$refs.hotTableTemas.hotInstance

    yo.settings = {
      width: '100%', //Ancho
      height: '55vh',
      rowHeaders: true, //Activar numeración de filas
      colHeaders: [
        'ID',
        'ESTADO',
        'TIPO',
        'MODELO',
        'CÓDIGO DEL TEMA',
        'CÓDIGO DEL MATERIAL',
        'TEMA',
        'TEMARIO',
        'OBJETIVO',
        'GRUPO OBJETIVO',
        'PARTICIPANTES',
        'DNI EXPOSITOR',
        'EXPOSITOR',
        'PROCEDENCIA',
        'FECHA',
        'HORA INICIO',
        'HORA FIN',
        'TIEMPO ESTIMADO',
        'EMPRESA',
        'UNIDAD',
        'SEDE',
        'AREA USUARIA',
        'DEPARTAMENTO',
        'ÁREA',
        'SECCIÓN',
        'ZONA',
        'CULTIVO',
        'ACTIVIDAD',
        'MODALIDAD',
        'ESCUELA',
        'CATEGORÍA',
        'ÁREA RESPONSABLE',
        'MES_AÑO',
        'TIPO',
        'MATERIAL',
      ],
      columns: [
        {
          data: 'id',
        },
        {
          data: 'estado',
          editor: 'select',
          className: 'htCenter htMiddle',
          allowInvalid: false,
          selectOptions: [
            'PENDIENTE',
            'EN PROCESO',
            'REALIZADO',
            'DESHABILITADO',
          ],
          renderer(instance, td, row, col, prop, value, cellProperties) {
            let valor = ''

            valor = value === null ? '' : value

            const spd =
                valor === 'PENDIENTE'
                    ? 'light-warning'
                    : valor === 'REALIZADO'
                        ? 'light-success'
                        : valor === 'CANCELADO'
                            ? 'light-danger'
                            : valor === 'EN PROCESO'
                                ? 'light-info'
                                : 'light-dark'

            td.className = 'htCenter htMiddle'
            td.innerHTML =
                '<b-badge class="badge badge-' +
                spd +
                '">' +
                valor +
                '</b-badge>'

            return td
          },
        },
        {
          data: 'tipo_capacitacion',
          type: 'dropdown',
          className: 'htCenter htMiddle',
          source: ['PRESENCIAL', 'VIRTUAL'],
        },
        {
          data: 'modelo',
          type: 'dropdown',
          className: 'htCenter htMiddle',
          source: ['CERTIFICACIONES', 'ECA'],
        },
        {
          data: 'codigo',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'cod_material',
          type: 'text',
          className: 'htCenter htMiddle',

        },
        {
          data: 'tema',
          type: 'text',
          className: 'htMiddle',
        },
        {
          data: 'temario',
          type: 'text',
          className: 'htMiddle',
        },
        {
          data: 'objetivo',
          type: 'text',
          className: 'htMiddle',
        },
        {
          data: 'planilla',
          type: 'dropdown',
          className: 'htMiddle',
          source: [
            'OBREROS',
            'EMPLEADOS',
            'OBREROS Y EMPLEADOS',
            'OBREROS CALIFICADOS Y EMPLEADOS',
            'OBREROS Y OBREROS CALIFICADOS',
          ],
        },
        {
          data: 'participantes',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'dni_expositor',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'expositor',
          type: 'text',
          className: 'htMiddle',
        },
        {
          data: 'procedencia_expositor',
          type: 'dropdown',
          className: 'htMiddle',
          source: ['AGROVISION PERU SAC', 'ARENA VERDE SAC'],
        },
        {
          data: 'fecha',
          type: 'date',
          dateFormat: 'YYYY-MM-DD',
          className: 'htCenter htMiddle',
        },
        {
          data: 'hora_inicio',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'hora_fin',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'total_horas',
          type: 'text',
          className: 'htCenter htMiddle',
        },
        {
          data: 'empresa',
          type: 'dropdown',
          className: 'htCenter htMiddle',
          source: ['AGROVISION PERU SAC', 'ARENA VERDE SAC'],
        },
        {
          data: 'unidad',
          type: 'dropdown',
          className: 'htCenter htMiddle',
          source: ['AGRÍCOLA', 'INDUSTRIAL'],
        },
        {
          data: 'sede',
          type: 'dropdown',
          className: 'htCenter htMiddle',
          source: [
            'CAMPAMENTO',
            'CAJAMARCA',
            'CARHUAZ',
            'CHICLAYO',
            'LIMA',
            'LOTE CENTRO',
            'LOTE NORTE',
            'LOTE SAN RICARDO',
            'OLMOS A9',
            'OLMOS B1',
            'OLMOS C5',
          ],
        },
        {
          data: 'area_usuaria',
          type: 'dropdown',
          className: 'htCenter htMiddle',
          source: [
            'SEGURIDAD Y SALUD EN EL TRABAJO',
            'SALUD OCUPACIONAL',
            'GESTIÓN HUMANA',
            'BIENESTAR SOCIAL',
            'ADMINISTRACIÓN',
            'SEGURIDAD PATRIMONIAL',
            'GESTIÓN Y DESARROLLO HUMANO',
            'FOOD SAFETY',
          ],
        },
        {
          data: 'departamento',
          type: 'dropdown',
          className: 'htMiddle',
          source: [
            'ADMINISTRACIÓN Y ASUNTOS CORPORATIVOS',
            'INNOVACIÓN Y NUEVOS NEGOCIOS',
            'FINANZAS',
            'SERVICIOS Y DESARROLLO AGRÍCOLA',
            'OPERACIONES AGRÍCOLAS',
            'GESTIÓN HUMANA',
            'COMITÉ SST',
            'GRUPO EFI',
            'VARIOS',
            'BRIGADISTAS DE CAMPO',
          ],
        },
        {
          data: 'area',
          type: 'dropdown',
          className: 'htMiddle',
          source: [
            'ADMINISTRACIÓN Y ASUNTOS CORPORATIVOS',
            'ADMINISTRACIÓN DE FUNDO',
            'SEGURIDAD PATRIMONIAL',
            'INNOVACIÓN Y NUEVOS NEGOCIOS',
            'ASEGURAMIENTO DE LA CALIDAD',
            'INVESTIGACIÓN Y DESARROLLO',
            'AGRICULTURA DE PRECISIÓN',
            'FINANZAS',
            'LOGÍSTICA',
            'TECNOLOGÍA DE LA INFORMACIÓN',
            'SERVICIOS Y DESARROLLO AGRÍCOLA',
            'GESTIÓN HUMANA',
            'SOPORTE OPERATIVO',
            'OPERACIONES AGRÍCOLAS',
            'UN ARÁNDANO',
            'UN ESPÁRRAGO',
            'UN VID',
            'UN PALTA',
            'UN LIMÓN',
            'PLANIFICACIÓN Y CONTROL DE GESTIÓN AGRÍCOLA',
            'GESTIÓN DE LA INFORMACIÓN',
            'PACKING',
            'COMITÉ SST',
            'GRUPO EFI',
            'BRIGADISTAS DE CAMPO',
            'ASUNTOS CORPORATIVOS Y SOSTENIBILIDAD',
            'PRODUCCION DE ALIMENTOS',
            'MEJORA CONTINUA',
            'RELACIONES COMUNITARIAS',
          ],
        },
        {
          data: 'seccion',
          type: 'dropdown',
          className: 'htMiddle',
          source: [
            'ADMINISTRACIÓN Y ASUNTOS CORPORATIVOS',
            'ADMINISTRACIÓN',
            'CASA HACIENDA',
            'COMEDOR',
            'FORESTAL',
            'MANTENIMIENTO CAMPAMENTO',
            'SEGURIDAD PATRIMONIAL',
            'INNOVACIÓN Y NUEVOS NEGOCIOS',
            'ASEGURAMIENTO DE LA CALIDAD',
            'FOOD SAFETY',
            'CALIDAD Y POSCOSECHA',
            'CONTROL DE PROCESOS',
            'LABORATORIO',
            'INVESTIGACIÓN Y DESARROLLO',
            'AGRICULTURA DE PRECISIÓN',
            'FINANZAS',
            'LOGÍSTICA',
            'ALMACENES',
            'TECNOLOGÍA DE LA INFORMACIÓN',
            'SERVICIOS Y DESARROLLO AGRÍCOLA',
            'RIEGO Y FERTILIZACIÓN',
            'MO Y MAQUINARIA',
            'MANEJO INTEGRADO DE PLAGAS',
            'MANTENIMIENTO AGRÍCOLA',
            'GESTIÓN HUMANA',
            'PLANNER',
            'ADM. PERSONAL Y COMPENSACIONES',
            'GESTIÓN Y DESARROLLO HUMANO',
            'RECLUTAMIENTO Y RETENCIÓN',
            'GESTIÓN HUMANA / SOPORTE OPERACIONES',
            'CAMPO',
            'SEGURIDAD Y SALUD EN EL TRABAJO',
            'BIENESTAR SOCIAL',
            'TRANSPORTE',
            'CCC',
            'SOPORTE OPERATIVO',
            'OPERACIONES AGRÍCOLAS',
            'UN ARÁNDANO',
            'FITOSANIDAD',
            'PRODUCCIÓN',
            'GESTIÓN E INVESTIGACIÓN AGRÍCOLA',
            'COSECHA',
            'UN ESPÁRRAGO',
            'UN VID',
            'FENOLOGÍA',
            'UN PALTA',
            'PLANIFICACIÓN Y CONTROL DE OPERACIONES AGRÍCOLA',
            'MAQUINARIA ARÁNDANO',
            'RIEGO Y SERVICIOS AGRÍCOLAS',
            'PRODUCCIÓN / ALMACENES',
            'PRODUCCIÓN / MANTENIMIENTO',
            'PRODUCCIÓN / ACOPIO',
            'PRODUCCIÓN / FRÍO',
            'PRODUCCIÓN / INOCUIDAD Y BPM',
            'PRODUCCIÓN / EMPAQUE',
            'PACKING',
            'PRODUCCIÓN (APICULTURA Y CARPINTERIA)',
            'CAMPAMENTO',
            'SERVICIOS DE ALIMENTACIÓN',
            'COMPRAS',
            'COSECHA (TRANSPORTE DE MATERIA PRIMA)',
            'RIEGO Y FERTILIZACION ARÁNDANO',
            'COMITÉ SST',
            'GRUPO EFI',
            'CONSTRUCCIÓN Y OBRAS CIVILES',
            'PLANTA DE AGUA',
            'RIEGO SERVICIOS AGRÍCOLAS',
            'RIEGO SERVICIOS AGRICOLAS(MANTENIMIENTO)',
            'BRIGADISTAS DE CAMPO',
            'MEDIO AMBIENTE',
            'PLANIFICACIÓN Y CONTROL DE GESTIÓN AGRÍCOLA',
            'PROCESOS Y DATA',
            'ANALÍTICA DE DATOS Y BI',
            'PRODUCCIÓN/MANTENIMIENTO (MÉC,.ELÉC.FRIG.SS.GG)',
            'PRODUCCIÓN/MANTENIMIENTO (MÉC,.ELÉC.FRIG.SS.GG. BRIG.)',
            'PRODUCCIÓN/MANTENIMIENTO (ELÉC.FRIG.)',
            'PRODUCCIÓN/MANTENIMIENTO (SS:GG)',
            'PRODUCCIÓN/MANTENIMIENTO (MÉC,.ELÉC.FRIG.)',
            'PRODUCCIÓN/MANTENIMIENTO (OP. DE MONTA, P.ELEV)',
            'PRODUCCIÓN/MANTEMIENTO (SS:GG. FRIG)',
            'PRODUCCIÓN/MANTENIMIENTO (FRIGORISTA)',
            'PRODUCCIÓN / ALMACÉN (OP /BRIG)',
            'PRODUCCIÓN / ALMACÉN (OP. MONTA)',
            'PRODUCCIÓN / INOCUIDAD Y BPM (OP/ BRIG)',
            'PRODUCCIÓN / INOCUIDAD Y BPM (OP. PLAT. ELEV)',
            'PRODUCCIÓN / FRIO (OP / BRIG)',
            'PRODUCCIÓN / FRIO (OP.MONTA, TRANSPALLET)',
            'PRODUCCIÓN /ACOPIO (OP. MONTA)',
            'PRODUCCIÓN /ACOPIO (RECEPCIÓN MP)',
            'PRODUCCIÓN /ACOPIO (RECEPCIÓN MP/ BRIG)',
            'PRODUCCIÓN / ACOPIO (LAVADO DE JABAS)',
            'PRODUCCIÓN / ACOPIO - PRE FRÍO',
            'PRODUCCIÓN / ACOPIO - GASIFICADO',
            'PRODUCCIÓN / ACOPIO - GASIFICADO (OP / BRIG)',
            'PACKING (OP/ BRIG)',
            'PRODUCCIÓN / EMPAQUE ARÁNDANO (PLAN. DIG.ADM)',
            'PRODUCCIÓN / EMPAQUE ARÁNDANO (PLAN. DIG.ADM. BRIG)',
            'PRODUCCIÓN / EMPAQUE UVA (PLAN. DIG.ADM)',
            'PRODUCCIÓN / EMPAQUE PALTO (PLAN. DIG.ADM)',
            'PRODUCCIÓN / EMPAQUE ESPÁRRAGO(PLAN. DIG.ADM)',
            'ASEGURAMIENTO DE LA CALIDAD (OP/BRIG)',
            'PRODUCCIÓN /GESTIÓN DE PROCESOS',
            'CALIDAD',
            'PLANIFICACIÓN',
            'PRODUCCIÓN ( BRIGADISTAS)',
            'RIEGO Y FERTILIZACIÓN ( BRIGADISTAS)',
            'PRODUCCIÓN (BRIGADISTAS)',
            'PRODUCCION / EMPAQUE (BRIGADISTAS)',
            'PRODUCCION / ACOPIO (BRIGADISTAS)',
            'PRODUCCION / FRIO (BRIGADISTAS)',
            'PRODUCCION / MANTENIMIENTO (BRIGADISTAS)',
            'PRODUCCION / INOCUIDAD Y BPM (BRIGADISTAS)',
            'PRODUCCION / GESTION DE PROCESOS',
            'PRODUCCION DE ALIMENTOS',
            'LEAN Y MEJORA CONTINUA',
            'OFICINAS ADMINISTRATIVAS',
            'RRHH',
            'CERCO PERIMETRAL',
            'RELACIONES COMUNITARIAS',
            'REFORESTACIÓN',
          ],
        },
        {
          data: 'zona',
          type: 'text',
          className: 'htMiddle',
        },
        {
          data: 'cultivo',
          type: 'dropdown',
          className: 'htMiddle',
          source: [
            'TRANSVERSAL',
            'UN ARÁNDANO',
            'UN CEREZA',
            'UN ESPÁRRAGO',
            'UN VID',
            'UN PALTA',
            'UN LIMÓN',
          ],
        },
        {
          data: 'actividad',
          type: 'dropdown',
          className: 'htMiddle',
          source: [
            'INDUCCIÓN',
            'CAPACITACIÓN',
            'ENTRENAMIENTO',
            'SIMULACRO',
            'CHARLA',
          ],
        },
        {
          data: 'modalidad',
          type: 'dropdown',
          className: 'htMiddle',
          source: ['INTERNA', 'INHOUSE'],
        },
        {
          data: 'escuela',
          type: 'dropdown',
          className: 'htMiddle',
          source: [
            'SISTEMA INTEGRADO DE GESTIÓN',
            'TÉCNICA',
            'GESTIÓN Y LIDERAZGO',
            'OTROS',
          ],
        },
        {
          data: 'categoria',
          type: 'dropdown',
          className: 'htMiddle',
          source: [
            'SEGURIDAD Y SALUD EN EL TRABAJO',
            'BRC/IFS',
            'GLOBAL GAP',
            'BASC',
            'FSMA',
            'BPM',
            'HACCP',
            'GESTIÓN AMBIENTAL',
            'RESPONSABILIDAD SOCIAL',
            'PROCESO TÉCNICO',
            'OTROS',
          ],
        },
        {
          data: 'area_responsable',
          type: 'dropdown',
          className: 'htMiddle',
          source: [
            'SEGURIDAD Y SALUD EN EL TRABAJO',
            'SALUD OCUPACIONAL',
            'GESTIÓN HUMANA',
            'BIENESTAR SOCIAL',
            'ADMINISTRACIÓN',
            'SEGURIDAD PATRIMONIAL',
            'GESTIÓN Y DESARROLLO HUMANO',
            'FOOD SAFETY',
          ],
        },
        {
          data: 'mes_anio',
          type: 'dropdown',
          className: 'htCenter htMiddle',
          source: [
            '2024-12',
            '2024-11',
            '2024-10',
            '2024-09',
            '2024-08',
            '2024-07',
            '2024-06',
            '2024-05',
            '2024-04',
            '2024-03',
            '2024-02',
            '2024-01',
            '2023-12',
            '2023-11',
            '2023-10',
            '2023-09',
            '2023-08',
            '2023-07',
            '2023-06',
            '2023-05',
            '2023-04',
            '2023-03',
            '2023-02',
            '2023-01',
            '2022-12',
            '2022-11',
          ],
        },
        {
          data: 'tipo',
        },
        {
          data: 'material',
        },
      ],
      language: esMX.languageCode, // Lenguaje español
      locale: 'es-MX',
      dropdownMenu: [
        'filter_by_condition',
        'filter_by_value',
        'filter_action_bar',
      ], // Activar menú
      filters: true,
      contextMenu: {
        items: {
          editar: {
            name: 'Editar',
            callback: function () {
              if (yo.$can('edit', 'Temas Capacitaciones')) {
                const fila = this.getSelected()[0][0]
                for (let col = 0; col <= 32; col++) {
                  yo.tabla.setCellMeta(fila, col, 'readOnly', false)
                  const existingClasses = yo.tabla.getCellMeta(
                      fila,
                      col
                  ).className
                  yo.tabla.setCellMeta(
                      fila,
                      col,
                      'className',
                      existingClasses + ' tenue-amarillo'
                  )
                  // yo.tabla.setCellMeta(this.getSelected()[0][0], col, 'className', 'tenue-amarillo');
                }
                this.render()
              }
            },
          },
          material: {
            name: 'Asignar Material',
            callback: function () {
              if (yo.$can('create', 'Temas Capacitaciones')) {
                const rowData = this.getDataAtRow(this.getSelected()[0][0])
                yo.verMateriales(rowData[0], rowData[6])
              }

            },
          },
          downloadMaterial: {
            name: 'Descargar o Ver Material',
            callback: function () {
              if (yo.$can('create', 'Temas Capacitaciones')) {
                const rowData = this.getDataAtRow(this.getSelected()[0][0])
                yo.descargarMaterial(rowData[34])
              }
            },
          },
        },
      },
      columnSorting: true,
      manualColumnResize: true,
      readOnly: true,
      afterChange: this.afterChangeFuncion,
      fixedColumnsStart: 2,
      afterFilter: yo.afterFilterFuncion,
    }

    this.generarListaMesesDesdeNoviembre2022()
    yo.traerTemas()
    localize('es')
  },
  methods: {
    traerTemas() {
      const yo = this
      yo.loading = true
      yo.tabla.updateData([])
      yo.totalRows = 0
      let mes_select = null

      if (yo.meses_list_select === null) {
        const now = new Date()
        const anio = now.getUTCFullYear()
            .toString()
        const mes =
            (now.getMonth() + 1).toString().length === 1
                ? '0' + (now.getMonth() + 1)
                : now.getMonth() + 1
        mes_select = anio + '-' + mes
      } else {
        mes_select = yo.meses_list_select
      }

      yo.meses_list_select = mes_select

      const data = JSON.stringify({
        mes: yo.meses_list_select,
      })

      const config = {
        method: 'post',
        url: '/capacitacion/capacitaciones/web/',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              yo.items = response.data
              yo.totalRows = yo.items.length

              yo.tabla.updateData(response.data)
              yo.settings.hiddenColumns = {
                columns: [0, 33, 34],
              }
              yo.tabla.updateSettings(yo.settings)
              // yo.tabla.getPlugin('autoColumnSize').recalculateAllColumnsWidth()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            yo.loading = false
            // yo.realizarFiltro('', ['a'])
          })
    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    traerTemasCompleto() {
      const yo = this
      yo.loading = true

      const config = {
        method: 'get',
        url: '/capacitacion/capacitaciones/web/completo',
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              yo.items = response.data

              yo.empresaFiltro = []
              yo.sedeFiltro = []
              yo.unidadFiltro = []
              yo.temaFiltro = []
              yo.actividadFiltro = []
              yo.categoriaFiltro = []
              yo.seccionFiltro = []
              yo.area_responsableFiltro = []

              for (let value of yo.items) {
                if (
                    value.empresa !== null &&
                    value.empresa !== '' &&
                    value.empresa !== ' ' &&
                    value.empresa !== '  '
                ) {
                  yo.empresaFiltro.push(value.empresa)
                }
                if (
                    value.sede !== null &&
                    value.sede !== '' &&
                    value.sede !== ' ' &&
                    value.sede !== '  '
                ) {
                  yo.sedeFiltro.push(value.sede)
                }
                if (
                    value.unidad !== null &&
                    value.unidad !== '' &&
                    value.unidad !== ' ' &&
                    value.unidad !== '  '
                ) {
                  yo.unidadFiltro.push(value.unidad)
                }
                if (
                    value.tema !== null &&
                    value.tema !== '' &&
                    value.tema !== ' ' &&
                    value.tema !== '  '
                ) {
                  yo.temaFiltro.push(value.tema)
                }
                if (
                    value.actividad !== null &&
                    value.actividad !== '' &&
                    value.actividad !== ' ' &&
                    value.actividad !== '  '
                ) {
                  yo.actividadFiltro.push(value.actividad)
                }
                if (
                    value.categoria !== null &&
                    value.categoria !== '' &&
                    value.categoria !== ' ' &&
                    value.categoria !== '  '
                ) {
                  yo.categoriaFiltro.push(value.categoria)
                }
                if (
                    value.seccion !== null &&
                    value.seccion !== '' &&
                    value.seccion !== ' ' &&
                    value.seccion !== '  '
                ) {
                  yo.seccionFiltro.push(value.seccion)
                }
                if (
                    value.area_responsable !== null &&
                    value.area_responsable !== '' &&
                    value.area_responsable !== ' ' &&
                    value.area_responsable !== '  '
                ) {
                  yo.area_responsableFiltro.push(value.area_responsable)
                }
              }

              yo.empresaFiltro = [...new Set(yo.empresaFiltro)].sort()
              yo.sedeFiltro = [...new Set(yo.sedeFiltro)].sort()
              yo.unidadFiltro = [...new Set(yo.unidadFiltro)].sort()
              yo.temaFiltro = [...new Set(yo.temaFiltro)].sort()
              yo.actividadFiltro = [...new Set(yo.actividadFiltro)].sort()
              yo.categoriaFiltro = [...new Set(yo.categoriaFiltro)].sort()
              yo.seccionFiltro = [...new Set(yo.seccionFiltro)].sort()
              yo.area_responsableFiltro = [
                ...new Set(yo.area_responsableFiltro),
              ].sort()

              yo.empresaFiltro.push('VACIOS')
              yo.sedeFiltro.push('VACIOS')
              yo.unidadFiltro.push('VACIOS')
              yo.temaFiltro.push('VACIOS')
              yo.actividadFiltro.push('VACIOS')
              yo.categoriaFiltro.push('VACIOS')
              yo.seccionFiltro.push('VACIOS')
              yo.area_responsableFiltro.push('VACIOS')

              yo.itemsFiltro = yo.items
            }
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            yo.loading = false
            yo.realizarFiltro('', ['a'])
          })
    },

    handleSubmit() {
      this.$refs.formularioFertilizacion.validate()
          .then((success) => {
            if (success) {
            }
          })
    },

    resetModal() {
      const yo = this
      yo.id_editar = null
      yo.unidad = null
      yo.empresa = null
      yo.sede = null
      yo.area_usuaria = null
      yo.departamento = null
      yo.area = null
      yo.seccion = null
      yo.zona = null
      yo.cultivo = null
      yo.tema = null
      yo.temario = null
      yo.objetivo = null
      yo.planilla = null
      yo.participantes = null
      yo.cod_material = null
      yo.dni_expositor = null
      yo.expositor = null
      yo.procedencia_expositor = null
      yo.fecha = null
      yo.hora_inicio = null
      yo.hora_fin = null
      yo.total_horas = null
      yo.actividad = null
      yo.modalidad = null
      yo.escuela = null
      yo.categoria = null
      yo.area_responsable = null
      yo.estado = null

      yo.mesSelected = null
      yo.anio = null
    },

    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },

    calcularRestaHoras() {
      const yo = this
      const a = new Date(yo.fecha + ' ' + yo.hora_inicio)
      const b = new Date(yo.fecha + ' ' + yo.hora_fin)

      if (a < b) {
        yo.total_horas = (b - a) / 1000 / 60 + ' minutos'
      } else {
        yo.total_horas = null
      }
    },

    importarOk(bvModalEvtImp) {
      // Prevent modal from closing
      bvModalEvtImp.preventDefault()
      // Trigger submit handler
      this.enviarExcelMasivos()
    },

    enviarExcelMasivos(){                
      const yo = this

      this.$refs.formularioImportarTemas.validate().then(success => {
        if (success) {
          yo.loadingCarga = true
          const data = new FormData();
          data.append('file', yo.archivo_excel)

          const config = {
            method: 'post',
            url: '/capacitacion/archivo/cargar_temas_masivos/',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            responseType: 'blob', // Para poder manejar ambos tipos de respuesta
            data : data
          };

          axiosIns(config)
              .then(async function (response) {
                const contentType = response.headers['content-type'];
                console.log("Tipo de contenido recibido:", contentType);
                
                // Si la respuesta es un archivo Excel (hay errores en la importación)
                if (contentType.includes('application/vnd.openxmlformats-officedocument') || 
                    contentType.includes('application/vnd.ms-excel') ||
                    contentType.includes('application/octet-stream')) {
                  
                  try {
                    console.log("Recibido archivo Excel con errores de importación");
                    // Crear un blob y descargar el archivo Excel de errores
                    const blob = new Blob([response.data], { 
                      type: contentType 
                    });
                    
                    // Crear y descargar el archivo
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'errores_importacion_temas.xlsx');
                    document.body.appendChild(link);
                    
                    link.click();
                    // Limpiar
                    setTimeout(() => {
                      document.body.removeChild(link);
                      window.URL.revokeObjectURL(url);
                    }, 100);

                    yo.mostrarNotificacion(
                      'Importación con observaciones', 
                      'AlertTriangleIcon', 
                      'Se completó la importación parcialmente. Se ha descargado un archivo con los detalles de los errores.', 
                      'warning', 
                      5000
                    );
                    
                    // Actualizar temas ya que la importación parcial pudo haber agregado algunos
                    yo.traerTemas(); 
                  } catch (err) {
                    console.error("Error al procesar el archivo para descarga:", err);
                    yo.mostrarNotificacion(
                      'Error al descargar archivo', 
                      'XIcon', 
                      'Se procesó la importación pero hubo un problema al descargar el archivo de errores.', 
                      'warning', 
                      5000
                    );
                  }
                } 
                // Si la respuesta es un JSON (no hay errores)
                else if (contentType.includes('application/json')) {
                  try {
                    // Convertir el blob a texto
                    const text = await response.data.text();
                    const responseData = JSON.parse(text);
                    
                    if (responseData.estado === true) {
                      yo.traerTemas();
                      yo.mostrarNotificacion(
                        '¡Importación exitosa!', 
                        'CheckIcon', 
                        `Se importaron ${responseData.total} registros correctamente.`, 
                        'success', 
                        5000
                      );
                    } else {
                      yo.mostrarNotificacion(
                        'Error en la importación', 
                        'BellIcon', 
                        responseData.message || 'Hubo un error en la importación.', 
                        'danger', 
                        5000
                      );
                    }
                  } catch (error) {
                    console.error("Error al procesar respuesta JSON:", error);
                    yo.mostrarNotificacion(
                      'Error en la importación', 
                      'BellIcon', 
                      'Hubo un error al procesar la respuesta del servidor.', 
                      'danger', 
                      5000
                    );
                  }
                } 
                // Tipo de contenido no esperado
                else {
                  console.warn("Tipo de contenido no esperado:", contentType);
                  yo.mostrarNotificacion(
                    'Respuesta no reconocida', 
                    'AlertTriangleIcon', 
                    'El servidor respondió con un formato no esperado.', 
                    'warning', 
                    5000
                  );
                }
              })
              .catch(async function (error) {
                console.error("Error en la petición:", error);
                let errorMessage = 'Hubo un error en el registro, inténtelo nuevamente en unos minutos.';
                
                // Intentar extraer mensaje de error si es posible
                if (error.response) {
                  try {
                    if (error.response.data instanceof Blob) {
                      const text = await error.response.data.text();
                      try {
                        const data = JSON.parse(text);
                        errorMessage = data.message || error.response.statusText;
                      } catch {
                        errorMessage = "Error en la petición. Código: " + error.response.status;
                      }
                    } else {
                      errorMessage = error.response.data.message || error.response.statusText;
                    }
                  } catch {
                    errorMessage = error.response.statusText || error.message;
                  }
                } else {
                  errorMessage = error.message;
                }
                
                yo.mostrarNotificacion('Error en el registro', 'BellIcon', errorMessage, 'danger', 5000)
              })
              .finally(function () {
                yo.archivo_excel = null;
                yo.loadingCarga = false;
                yo.$nextTick(() => {
                  yo.$refs['modal_importar'].toggle('#toggle-btn')
                });
              })
          ;
        }
      })
    },

    validarRegistro(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.registrarTema()
    },

    validarRegistroEditar(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.editarTema()
    },

    registrarTema() {
      const yo = this

      this.$refs.formularioTemas.validate()
          .then((success) => {
            if (success) {
              yo.loading2 = true

              if (yo.fecha) {
                yo.mesSelected = yo.fecha.substr(5, 2)
                // console.log(yo.mesSelected)
                yo.anio = yo.fecha.substr(0, 4)
                // console.log(yo.anio)

                yo.mes_anio = yo.anio + '-' + yo.mesSelected
              } else {
                yo.mes_anio = yo.anio + '-' + yo.mesSelected
              }

              const data = new FormData();
              data.append('unidad', yo.unidad !== null ? yo.unidad : '')
              data.append('empresa', yo.empresa !== null ? yo.empresa : '')
              data.append('sede', yo.sede !== null ? yo.sede : '')
              data.append('area_usuaria', yo.area_usuaria !== null ? yo.area_usuaria : '')
              data.append('departamento', yo.departamento !== null ? yo.departamento : '')
              data.append('area', yo.area !== null ? yo.area : '')
              data.append('seccion', yo.seccion !== null ? yo.seccion : '')
              data.append('zona', yo.zona !== null ? yo.zona : '')
              data.append('cultivo', yo.cultivo !== null ? yo.cultivo : '')
              data.append('tema', yo.tema !== null ? yo.tema : '')
              data.append('temario', yo.temario !== null ? yo.temario : '')
              data.append('objetivo', yo.objetivo !== null ? yo.objetivo : '')
              data.append('planilla', yo.planilla !== null ? yo.planilla : '')
              data.append('participantes', yo.participantes !== null ? yo.participantes : '')
              data.append('cod_material', yo.cod_material !== null ? yo.cod_material : '')
              data.append('dni_expositor', yo.dni_expositor !== null ? yo.dni_expositor : '')
              data.append('expositor', yo.expositor !== null ? yo.expositor : '')
              data.append('procedencia_expositor', yo.procedencia_expositor !== null ? yo.procedencia_expositor : '')
              data.append('fecha', yo.fecha !== null ? yo.fecha : '')
              data.append('hora_inicio', yo.hora_inicio !== null ? yo.hora_inicio : '')
              data.append('hora_fin', yo.hora_fin !== null ? yo.hora_fin : '')
              data.append('total_horas', yo.total_horas !== null ? yo.total_horas : '')
              data.append('actividad', yo.actividad !== null ? yo.actividad : '')
              data.append('modalidad', yo.modalidad !== null ? yo.modalidad : '')
              data.append('escuela', yo.escuela !== null ? yo.escuela : '')
              data.append('categoria', yo.categoria !== null ? yo.categoria : '')
              data.append('area_responsable', yo.area_responsable !== null ? yo.area_responsable : '')
              data.append('tipo_capacitacion', yo.tipo !== null ? yo.tipo : '')
              data.append('modelo', yo.modelo !== null ? yo.modelo : '')
              data.append('estado', yo.tipo === 'VIRTUAL' ? '1' : '0')
              data.append('mes_anio', yo.mes_anio !== null ? yo.mes_anio : '')
              data.append('tipo', 'SI')
              data.append('material', yo.material)
              data.append('cod_material', yo.codMaterial)

              const config = {
                method: 'post',
                url: 'capacitacion/capacitaciones/crear/',
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
                data: data,
              }

              axiosIns(config)
                  .then(function (response) {
                    if (response.status === 201) {
                      yo.mostrarNotificacion(
                          '¡Bien hecho!',
                          'CheckIcon',
                          'El registro se realizó de manera correcta',
                          'success',
                          5000
                      )
                    }
                  })
                  .catch(function (error) {
                    console.log(error)
                    yo.mostrarNotificacion(
                        'Error en el registro',
                        'BellIcon',
                        'Error: \n ' + error.toString(),
                        'danger',
                        5000
                    )
                  })
                  .finally(function () {
                    yo.traerTemas()
                    yo.$nextTick(() => {
                      yo.$refs['modal_registro'].toggle('#toggle-btn')
                    })
                    yo.loading2 = false
                  })
            }
          })
    },

    editarTema() {
      const yo = this

      this.$refs.formularioTemasEditar.validate()
          .then((success) => {
            if (success) {
              yo.loadingEditar = true

              if (yo.fecha) {
                yo.mesSelected = yo.fecha.substr(5, 2)
                // console.log(yo.mesSelected)
                yo.anio = yo.fecha.substr(0, 4)
                // console.log(yo.anio)

                yo.mes_anio = yo.anio + '-' + yo.mesSelected
              } else {
                yo.mes_anio = yo.anio + '-' + yo.mesSelected
              }

              const data = JSON.stringify({
                unidad: yo.unidad,
                empresa: yo.empresa,
                sede: yo.sede,
                area_usuaria: yo.area_usuaria,
                departamento: yo.departamento,
                area: yo.area,
                seccion: yo.seccion,
                zona: yo.zona,
                cultivo: yo.cultivo,
                tema: yo.tema,
                temario: yo.temario,
                objetivo: yo.objetivo,
                planilla: yo.planilla,
                participantes: yo.participantes,
                cod_material: yo.cod_material,
                dni_expositor: yo.dni_expositor,
                expositor: yo.expositor,
                procedencia_expositor: yo.procedencia_expositor,
                fecha: yo.fecha,
                hora_inicio: yo.hora_inicio,
                hora_fin: yo.hora_fin,
                total_horas: yo.total_horas,
                actividad: yo.actividad,
                modalidad: yo.modalidad,
                escuela: yo.escuela,
                categoria: yo.categoria,
                area_responsable: yo.area_responsable,
                estado: yo.estado,

                mes_anio: yo.mes_anio,
              })

              const config = {
                method: 'put',
                url: 'capacitacion/capacitaciones/editar/' + yo.id_editar,
                headers: {
                  'Content-Type': 'application/json',
                },
                data: data,
              }

              axiosIns(config)
                  .then(function (response) {
                    if (response.status === 200) {
                      yo.mostrarNotificacion(
                          '¡Bien hecho!',
                          'CheckIcon',
                          'El registro se editó de manera correcta',
                          'success',
                          5000
                      )
                    }
                  })
                  .catch(function (error) {
                    console.log(error)
                    yo.mostrarNotificacion(
                        'Error en la edición',
                        'BellIcon',
                        'Error: \n ' + error.toString(),
                        'danger',
                        5000
                    )
                  })
                  .finally(function () {
                    yo.traerTemas()
                    yo.$nextTick(() => {
                      yo.$refs['modal_editar'].toggle('#toggle-btn')
                    })
                    yo.loadingEditar = false
                  })
            }
          })
    },

    deshabilitarTema(id, estado) {
      const yo = this
      // console.log("TE MUESTRO LOS ESTADOS")
      // console.log(id,estado)
      const data = JSON.stringify({
        id: id,
      })

      const config = {
        method: 'post',
        url: 'capacitacion/capacitaciones/deshabilitar/',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      }

      axiosIns(config)
          .then(function (response) {
            // console.log(response)
            // console.log(response.data.reg_existente)

            if (response.status === 200) {
              // if (response.data.reg_existente==='true'){
              //   yo.mostrarNotificacion('Error en la operación', 'BellIcon', "Ya existe un registro con ese DNI", 'danger', 6000)
              // }else{
              yo.mostrarNotificacion(
                  '¡Bien hecho!',
                  'CheckIcon',
                  'La operación se realizó correctamente.',
                  'success',
                  5000
              )
              // }
            }
          })
          .catch(function (error) {
            console.log(error)
            yo.mostrarNotificacion(
                'Error en la eliminación',
                'BellIcon',
                error.toString(),
                'danger',
                5000
            )
          })
          .finally(function () {
            yo.traerTemas()
            // yo.$nextTick(() => {
            //   yo.$refs['modal-registrar'].toggle('#toggle-btn')
            // })
            yo.loadingRegistrar = false
          })
    },

    mostrarNotificacion(titulo, icono, texto, variante, tiempo) {
      this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante,
            },
          },
          {
            timeout: tiempo,
            position: 'top-center',
          }
      )
    },

    mostrarModalEdit(datos) {
      const yo = this
      yo.mostrarModalEditar = true
      yo.id_editar = datos['id']
      yo.unidad = datos['unidad']
      yo.empresa = datos['empresa']
      yo.sede = datos['sede']
      yo.area_usuaria = datos['area_usuaria']
      yo.departamento = datos['departamento']
      yo.area = datos['area']
      yo.seccion = datos['seccion']
      yo.zona = datos['zona']
      yo.cultivo = datos['cultivo']
      yo.tema = datos['tema']
      yo.temario = datos['temario']
      yo.objetivo = datos['objetivo']
      yo.planilla = datos['planilla']
      yo.participantes = datos['participantes']
      yo.cod_material = datos['cod_material']
      yo.codigo = datos['codigo']
      yo.dni_expositor = datos['dni_expositor']
      yo.expositor = datos['expositor']
      yo.procedencia_expositor = datos['procedencia_expositor']
      yo.fecha = datos['fecha']
      yo.hora_inicio = datos['hora_inicio']
      yo.hora_fin = datos['hora_fin']
      yo.total_horas = datos['total_horas']
      yo.actividad = datos['actividad']
      yo.modalidad = datos['modalidad']
      yo.escuela = datos['escuela']
      yo.categoria = datos['categoria']
      yo.area_responsable = datos['area_responsable']
      yo.estado = datos['estado']

      //Valido si hay datos en fecha
      if (datos['fecha']) {
        yo.mesSelected = datos['fecha'].substr(5, 2)
        yo.anio = datos['fecha'].substr(0, 4)
      } else {
        yo.mesSelected = datos['mes_anio'].substr(5, 2)
        yo.anio = datos['mes_anio'].substr(0, 4)
      }
    },

    realizarFiltro(cabecera, data) {
      const yo = this
      let spd = yo.items

      let filt = []
      let c = 0

      let fecha = yo.fechaFiltro
      let fechaInicio = ''
      let fechaFin = ''
      let fechaHoy = ''

      if (fecha !== null && fecha !== '') {
        fecha = fecha.split(' a ')
        if (fecha.length === 1) {
          const [dia, mes, anio] = fecha[0].split('/')
          fechaInicio = new Date(+anio, mes - 1, +dia)
          fechaFin = new Date(+anio, mes - 1, +dia, 23, 59, 59)
        } else {
          const [dia, mes, anio] = fecha[0].split('/')
          const [dia1, mes1, anio1] = fecha[1].split('/')
          fechaInicio = new Date(+anio, mes - 1, +dia)
          fechaFin = new Date(+anio1, mes1 - 1, +dia1)
        }
      }

      for (const valor of yo.filtro) {
        if (valor.nombre === cabecera) {
          yo.filtro[c].valor = data
        }

        if (valor.nombre === 'fecha' && data.length === 0) {
          yo.fechaFiltro = null
          yo.filtro[c].valor = data
        }

        c += 1
      }

      for (const values of yo.filtro) {
        for (const column of values.valor) {
          spd.forEach(function (value) {
            if (column === 'VACIOS') {
              if (
                  value[values.nombre] === null ||
                  value[values.nombre] === '' ||
                  value[values.nombre] === ' ' ||
                  value[values.nombre] === '  '
              ) {
                filt.push(value)
              }
            } else {
              if (
                  values.nombre === 'fecha' &&
                  column !== null &&
                  value.fecha !== null
              ) {
                const [anios, mess, dias] = value.fecha.split('-')
                fechaHoy = new Date(+anios, mess - 1, +dias)

                if (fechaInicio !== '' && fechaFin !== '') {
                  if (
                      fechaHoy.getTime() >= fechaInicio.getTime() &&
                      fechaHoy.getTime() <= fechaFin.getTime()
                  ) {
                    filt.push(value)
                  }
                }
              } else {
                if (value[values.nombre] === column) {
                  filt.push(value)
                }
              }
            }
          })
        }

        if (values.valor.length > 0) {
          if (values.valor[0] !== null) {
            spd = filt
            filt = []
          }
        }
      }

      yo.itemsFiltro = spd
    },

    generarExcel() {
      const yo = this
      // const spd = yo.tabla.getData().map(subarray => subarray[0])
      // console.log(spd)
      yo.loadingMasivo = true

      const data = JSON.stringify({
        datas: [],
      })

      const config = {
        method: 'post',
        url: '/capacitacion/temas/exportar/filter/',
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'arraybuffer',
        data: data,
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(
                  new Blob([response.data])
              )
              const fileLink = document.createElement('a')
              fileLink.href = fileURL
              fileLink.setAttribute(
                  'download',
                  'Reporte de Capacitaciones Internas - Dashboard.xlsx'
              )
              document.body.appendChild(fileLink)
              fileLink.click()

              yo.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  }
              )
            }
          })
          .catch(function (error) {
            console.log(error)
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loadingMasivo = false
          })
    },

    generarExcelPlantilla() {
      const yo = this
      const spd = yo.tabla.getData()
          .map((subarray) => subarray[0])
      // console.log(spd)
      yo.loadingMasivoEditar = true

      if (spd.length > 0) {
        const data = JSON.stringify({
          datas: spd,
        })

        const config = {
          method: 'post',
          url: '/capacitacion/temas/exportar/filter/plantilla',
          headers: {
            'Content-Type': 'application/json',
          },
          responseType: 'arraybuffer',
          data: data,
        }

        axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {
                const fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                const fileLink = document.createElement('a')
                fileLink.href = fileURL
                fileLink.setAttribute(
                    'download',
                    'Reporte de Capacitaciones Internas - Dashboard.xlsx'
                )
                document.body.appendChild(fileLink)
                fileLink.click()

                yo.$toast(
                    {
                      component: ToastificationContent,
                      props: {
                        title: 'Archivo creado',
                        icon: 'CheckIcon',
                        text: 'El archivo se creó satisfactoriamente.',
                        variant: 'success',
                      },
                    },
                    {
                      position: 'top-center',
                    }
                )
              }
            })
            .catch(function (error) {
              console.log(error)
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error en la creación del archivo',
                  icon: 'XIcon',
                  text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                  variant: 'danger',
                },
              })
            })
            .finally(function () {
              yo.loadingMasivoEditar = false
            })
      } else {
        yo.$toast(
            {
              component: ToastificationContent,
              props: {
                title: '¡Advertencia!',
                icon: 'AlertTriangleIcon',
                text: 'No se encuentran registros para exportar.',
                variant: 'warning',
              },
            },
            {
              position: 'top-center',
            }
        )
      }
    },

    verLinks(id, tema, creado) {
      this.verLink = true

      const url_base = window.location.origin

      /*
      const fecha = new Date(creado);

      const dia = fecha.getDate().toString().padStart(2, '0');
      const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const anio = fecha.getFullYear().toString();
      const hora = fecha.getHours().toString().padStart(2, '0');
      const minuto = fecha.getMinutes().toString().padStart(2, '0');
      const segundo = fecha.getSeconds().toString().padStart(2, '0');

      const fechaHoraFormateada = `${dia}-${mes}-${anio} ${hora}:${minuto}:${segundo}`;
      */

      let result = ''
      const characters =
          'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

      for (let i = 0; i < 16; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * characters.length)
        )
      }

      this.link =
          url_base +
          '/capacitacion/virtual/new/' +
          tema +
          '/' +
          id +
          '/' +
          result +
          '/' +
          creado
      // console.log(this.link)
    },

    afterFilterFuncion(conditionsStack) {
      const yo = this
      yo.totalRows = yo.tabla.getData().length
      yo.tabla.getPlugin('autoColumnSize')
          .recalculateAllColumnsWidth()
    },

    afterChangeFuncion(changes, source) {
      const yo = this

      if (source === 'CopyPaste.paste' && changes.length >= 24) {
        const addedRows = changes.reduce((rows, change) => {
          const row = change[0]
          if (!rows.includes(row)) {
            rows.push(row)
          }
          return rows
        }, [])

        // console.log(addedRows)
        addedRows.forEach((row) => {
          yo.tabla.setDataAtCell(row, 0, 'DUPLICADO')
          yo.tabla.setDataAtCell(row, 25, 0)
        })
      }

      if (source === 'edit') {
        const [fila, columna, antes, despues] = changes[0]
        if (antes !== despues) {
          const rowData = yo.tabla.getDataAtRow(fila)
          // const existingClasses = yo.tabla.getCellMeta(fila, yo.columnas[columna]).className;
          // yo.tabla.setCellMeta(fila, yo.columnas[columna], 'className', existingClasses + ' tenue-amarillo');
          yo.arrayEditar.push({
            id: rowData[0],
            columna: columna,
            cambio: despues,
          })
        }
      }

      yo.tabla.render()
    },

    registrarCambios() {
      const yo = this

      if (yo.arrayEditar.length > 0) {
        yo.loadingSave = true

        const data = JSON.stringify({
          editar: yo.arrayEditar,
        })

        const config = {
          method: 'post',
          url: '/capacitacion/capacitaciones/crear_editar/',
          headers: {
            'Content-Type': 'application/json',
          },
          data: data,
        }

        axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {
                yo.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Registros guardados',
                    icon: 'CheckIcon',
                    text: 'El envío de los registros se realizó satisfactoriamente.',
                    variant: 'success',
                  },
                })

                yo.arrayEditar = []
              }
            })
            .catch(function (error) {
              console.log(error)

              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error en el registro',
                  icon: 'XIcon',
                  text: 'Hubo un error en el registro, intentelo nuevamente en unos minutos.',
                  variant: 'danger',
                },
              })
            })
            .finally(function () {
              yo.loadingSave = false
              yo.traerTemas()
            })
      } else {
        yo.$toast({
          component: ToastificationContent,
          props: {
            title: '¡Advertencia!',
            icon: 'CheckIcon',
            text: 'No se encontraron cambios por guardar.',
            variant: 'warning',
          },
        })
      }
    },

    verMateriales(id, tema){
      this.verModalMaterial = true
      this.idMaterial = id
      this.temaMaterial = tema
    },

    validarRegistroMaterial(bvModalEvt) {

      bvModalEvt.preventDefault()

      this.registrarMaterial()
    },

    registrarMaterial(){
      const yo = this

      this.$refs.formularioMaterial.validate()
          .then((success) => {
            if (success) {
              yo.loadingMaterial = true

              const data = new FormData();
              data.append('material', yo.material)
              data.append('cod_material', yo.codMaterial)

              const config = {
                method: 'PATCH',
                url: 'capacitacion/capacitaciones/editar/' + yo.idMaterial,
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
                data: data,
              }

              axiosIns(config)
                  .then(function (response) {
                    if (response.status === 200) {
                      yo.mostrarNotificacion(
                          '¡Bien hecho!',
                          'CheckIcon',
                          'El registro del material se realizó de manera correcta',
                          'success',
                          5000
                      )
                    }
                  })
                  .catch(function (error) {
                    console.log(error)
                    yo.mostrarNotificacion(
                        'Error en el registro',
                        'BellIcon',
                        'Error: \n ' + error.toString(),
                        'danger',
                        5000
                    )
                  })
                  .finally(function () {
                    yo.traerTemas()
                    yo.$nextTick(() => {
                      yo.$refs['modal_material'].toggle('#toggle-btn')
                    })
                    yo.loadingMaterial = false
                  })
            }
          })
    },

    descargarMaterial(link){
      const yo = this
      if(link !== null && link !== ''){
        const config = {
          method: 'get',
          url: link,
          headers: {
            'Content-Type': 'application/json',
          },
        }

        axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {

                const a = document.createElement('a');

                a.href = axiosIns.defaults.baseURL + link;
                a.target = '_blank';
                a.download = link.split('/').pop();  // Intenta obtener el nombre del archivo del URL
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              }else{
                yo.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Advertencia',
                    icon: 'XIcon',
                    text: 'No se encontró un material asignado a esta capacitación.',
                    variant: 'warning',
                  },
                })
              }
            })
      } else {
        yo.$toast({
          component: ToastificationContent,
          props: {
            title: 'Advertencia',
            icon: 'XIcon',
            text: 'No se encontró un material asignado a esta capacitación.',
            variant: 'warning',
          },
        })
      }

    },

    generarListaMesesDesdeNoviembre2022() {
      let anio = 2022;
      let mes = 11; // Empezamos desde noviembre de 2022
      const hoy = new Date();
      const anioActual = hoy.getFullYear();
      const mesActual = hoy.getMonth() + 1; // Los meses en JS van de 0 a 11, sumamos 1
      let lista = [];

      while (anio < anioActual || (anio === anioActual && mes <= mesActual)) {
        let mesStr = mes < 10 ? `0${mes}` : `${mes}`; // Formatear mes con dos dígitos
        lista.unshift(`${anio}-${mesStr}`); // Insertar al inicio para mantener el orden descendente

        mes++; // Avanzamos un mes

        if (mes === 13) { // Si el mes llega a 13, avanzamos un año y reiniciamos el mes a enero
          mes = 1;
          anio++;
        }
      }

      this.meses_list = lista; // Se revierte para que esté en orden descendente
    }

  },
}
</script>

<style
    src="../../../node_modules/handsontable/dist/handsontable.full.css"
></style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Excel";
}

.alinear-una-sola-linea {
  white-space: nowrap !important;
}

.alinear-medioT {
  vertical-align: middle !important;
}

.tablitaT {
  min-height: 58vh !important;
}

.tablitaT::-webkit-scrollbar {
  width: 1.35vh;
  height: 1.35vh;
}

.tablitaT::-webkit-scrollbar-track {
  background-color: rgba(171, 171, 171, 0.35);
  border-radius: 6px;
  position: absolute;
}

.tablitaT::-webkit-scrollbar-thumb {
  background-image: linear-gradient(47deg, #82868b, #9ca0a4);
  border-radius: 6px;
  position: absolute;
}

.tenue-amarillo {
  background-color: rgba(204, 190, 41, 0.4) !important;
  font-weight: 500 !important;
  font-size: 12px !important;
}

.tenue-rojo {
  background-color: rgba(204, 114, 41, 0.4) !important;
  font-weight: 500 !important;
}

;
</style>
